import common from './common'
import featuresPay from './feature'

const id = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Produk/Varian",
        serialNumber: "Nomor Seri",
        noProductsFound: "Tidak ada produk ditemukan",
        searchByProductSku: "Cari berdasarkan produk/SKU",
        searchSerialNumbers: "Cari nomor seri",
        transactionDetails: "Detail Transaksi",
        notAvailable: "N/A",
        mainWarehouse: "Gudang Utama"
    },
    new_build_banner: {
        title: 'Versi baru:',
        is_available: 'kini tersedia',
        fallback_title: 'Versi baru aplikasi tersedia',
        desc: 'Segarkan untuk mendapatkan fitur dan peningkatan terbaru.',
        refreshing: 'Menyegarkan…',
        refresh_now: 'Segarkan Sekarang',
        later: 'Nanti',
        you_are_on: "Anda menggunakan"
    },
    short: {
        finance: 'Keuangan',
        stock: 'Stok'
    },
    onboarding: {
        welcome: 'Selamat Datang!',
        step: {
            product: {
                totalBreakdown: 'Rincian Total',
                overallFulfilment: 'Pemenuhan Keseluruhan',
                totalShippedQty: 'Total Jumlah Dikirim',
                totalReceivedQty: 'Total Jumlah Diterima',
                totalOrderedQty: 'Total Jumlah Dipesan',
                totalShippedOrdered: 'Total Dikirim / Dipesan',
                totalReceivedOrdered: 'Total Diterima / Dipesan',
                viewQty: 'Lihat Jumlah',
                fetchingQty: 'Mengambil rincian jumlah...',
                noStockInfo: 'Tidak ada informasi stok ditemukan',
                title: '65% Tercapai',
                description: 'Hanya 2 langkah lagi untuk memulai kesuksesan besar Anda!',
                Warehouse: "Gudang",
            },
            stock: {
                title: '95% Hampir Selesai!!',
                description: 'Hanya satu langkah lagi untuk memulai kesuksesan besar Anda! Selesaikan sekarang.'
            }
        },
        business: {
            title: 'Bisnis berhasil dibuat!',
            description: 'Hebat! Bisnis Anda telah terdaftar'
        },
        product: {
            title: 'Tambahkan produk pertama Anda',
            description: 'Tambahkan produk untuk mulai mencatat stok',
            Warehouse: "Gudang",
        },
        stock: {
            title: 'Coba tambahkan stok',
            description: 'Mulai mencatat stok masuk dan keluar'
        },
        action: {
            add_business: {
                title: 'Buat Bisnis',
                description: 'Ingin membuat bisnis baru? Klik di sini'
            },
            join_business: {
                title: 'Gabung Bisnis',
                description: 'Punya kode undangan? Gabung di sini'
            }
        }
    },
    business: {
        title: 'Pilih bisnis, buat baru, atau gabung',
        add_business: {
            title: 'Buat bisnis baru',
            name: 'Nama bisnis',
            name_placeholder: 'Masukkan nama',
            category: 'Kategori bisnis',
            category_placeholder: 'Pilih Kategori',
            button: 'Buat Bisnis'
        },
        edit_business: {
            title: 'Edit bisnis'
        },
        join_business: {
            title: 'Gabung Bisnis',
            input_code: 'Masukkan kode undangan di bawah:',
            field_placeholder: 'Kode undangan',
            confirm_title: 'Gabung',
            confirm_text: 'Anda akan menjadi bagian dari tim di '
        },
        no_business: 'Tidak ada bisnis tersedia',
        create_or_join: 'Buat atau gabung bisnis',
        message: {
            saved: 'Bisnis berhasil disimpan!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Transaksi stok negatif',
            isNegativeTransactionDisabledHint: 'Dengan mengaktifkan ini, Anda dapat mencegah transaksi yang akan menghasilkan stok negatif.',
            negativeStockError: 'Transaksi stok negatif dinonaktifkan'
        }
    },
    profile: {
        edit_profile: {
            title: 'Edit profil',
            name: 'Nama Lengkap',
            name_placeholder: 'Masukkan nama lengkap',
            email: 'Email',
            phone_number: 'Nomor Telepon'
        },
        message: {
            required_name: 'Nama wajib diisi'
        }
    },
    product: {
        weightedAverageCost: 'Biaya Rata-rata Tertimbang',
        weightedAverageValueLabel: 'Nilai Rata-rata Tertimbang',
        Product: 'Produk',
        hideZeroStock: 'Sembunyikan Stok Nol',
        allVariants: 'Semua Varian',
        choose_product: 'Pilih Produk',
        choose_product_empty: 'Pilih produk dan masukkan jumlah',
        choose_product_empty_manufacturing: 'Pilih produk dan masukkan jumlah produksi',
        search: {
            placeholder: 'Cari berdasarkan nama',
            tooltip: 'Buka pemindai',
            Warehouse: "Gudang",
        },
        column: {
            image: 'Foto',
            name: 'Nama',
            price: 'Harga',
            buying_price: 'Harga Modal',
            selling_price: 'Harga Jual',
            sku: 'SKU',
            stock: 'Stok',
            quantity: 'Jumlah',
            latest_stock: 'Sisa',
            product_deleted: 'Produk telah dihapus',
            info_not_found: 'Informasi tidak tersedia',
            expired_date: 'Tanggal Kedaluwarsa',
            invoice: 'Faktur'
        },
        no_product: 'Tidak Ada Produk Tersedia',
        no_product_subtitle: 'Tambahkan produk pertama Anda untuk mulai melacak stok, harga, dan penjualan.',
        create_first_product: 'Buat produk pertama Anda',
        add_product: {
            sku: 'Kode Produk',
            sku_placeholder: 'Kode Produk. Contoh: 12345',
            name: 'Nama Produk',
            name_placeholder: 'Masukkan Nama Produk',
            initial_stock: 'Stok Awal',
            initial_stock_placeholder: 'Masukkan Stok Awal',
            buying_price: 'Harga Modal',
            buying_price_placeholder: 'Masukkan Harga Modal',
            selling_price: 'Harga Jual',
            selling_price_placeholder: 'Masukkan Harga Jual',
            category: 'Kategori',
            category_placeholder: 'Pilih Kategori',
            add_selling_price: 'Tambah Harga Grosir',
            expired_date: 'Tanggal Kedaluwarsa',
            expired_date_placeholder: 'Pilih Tanggal',
            description: 'Deskripsi',
            description_placeholder: 'Masukkan Deskripsi',
            custom_label: 'Atribut',
            custom_label_placeholder: 'Masukkan Kunci',
            add_custom_label: 'Tambah Atribut Lain',
            Warehouse: "Gudang",
        },
        customerLabel: {},
        choose_selling_price: 'Pilih Harga Jual',
        selling_price: 'Harga Jual',
        total_product: 'Total Produk',
        total_quantity: 'Total Stok',
        total_buying_price: 'Total Harga Modal',
        total_selling_price: 'Total Harga Jual',
        message: {
            required_name: 'Nama produk wajib diisi',
            required_sku: 'SKU wajib diisi',
            required_category: 'Kategori wajib diisi',
            required_quantity: 'Stok awal wajib diisi',
            invalid_input_qty: 'Jumlah stok tidak valid',
            required_buying_price: 'Harga modal wajib diisi',
            required_selling_price: 'Harga jual wajib diisi',
            required_selling_price_name: 'Nama harga jual wajib diisi',
            required_selling_price_price: 'Harga jual wajib diisi'
        },
        viewMore: 'Lihat Selengkapnya',
        WarehouseDetails: 'Detail Gudang',
        WarehouseName: 'Nama Gudang',
        AddWarehouse: 'Tambah Gudang',
        WarehouseQty: 'Jumlah Gudang',
        Warehouse: 'Gudang',
        Warehouses: 'Gudang-Gudang',
        Variants: 'Varian',
        VariantName: 'Nama Varian',
        productVariant: 'Varian Produk',
        AddVariant: 'Tambah Varian',
        TranferItem: 'Transfer Barang',
        AddUnit: 'Unit Baru',
        InitialStkWarehouse: 'Stok awal diperlukan untuk menambahkan varian',
        InitialStockinwarehouse: 'Stok awal di gudang',
        TotalQuantity: 'Total Jumlah:',
        AddNote: 'Tambah Catatan (Harga modal)',
        AddNotetitle: 'Tambah Catatan',
        VariantSuccessMessage: 'Varian produk berhasil diperbarui',
        Next: 'Berikutnya',
        Submit: 'Kirim',
        INACTIVE: 'TIDAK AKTIF',
        errorone: 'Ups! Jumlah yang diminta untuk',
        errortwo: "tidak sesuai dengan jumlah yang dialokasikan di gudang. Silakan sesuaikan jumlah atau tambah stok.",
        SelectWarehouse: 'Pilih Gudang',
        SelectVariant: 'Pilih Varian',
        Discount: 'Diskon',
        DiscountDetails: 'Detail Diskon',
        FinalPrice: 'Harga Akhir',
        DiscountType: 'Jenis Diskon',
        DiscountPer: 'Diskon %',
        DiscountValue: 'Nilai Diskon',
        Discountonprice: 'Diskon pada harga',
        Discountondiscount: 'Diskon pada diskon',
        AdditionalDiscount: 'Diskon Tambahan',
        SellingPrice: 'Harga Jual:',
        Save: 'Simpan',
        OnOriginalPrice: 'Pada Harga Asli',
        OnDiscountedPrice: 'Pada Harga Diskon',
        columnSelector: {
            title: 'Tampilkan Kolom',
            columnsButton: 'Kolom',
            costPrice: 'Harga Beli',
            sellingPrice: 'Harga Jual',
            sku: 'SKU',
            warehouse: 'Gudang',
            categories: 'Kategori',
            safetyStock: 'Stok Pengaman',
            attributes: 'Atribut',
            notes: 'Catatan',
            description: 'Deskripsi',
            more: 'lebih banyak',
            attribute: 'Atribut',
            attributesTitle: 'Atribut',
            categoriesTitle: 'Kategori',
            skuAliases: 'Alias SKU'
        }
    },
    note: {
        title: 'Catatan',
        add: 'Tambah Catatan',
        no_note: 'Tidak ada catatan tersedia'
    },
    settings: {
        category: 'Kategori',
        language: 'Bahasa',
        switch_business: 'Ganti Bisnis',
        currencySelect: 'Mata Uang',
        languageChangeSuccess: 'Mata Uang Berhasil Diperbarui',
        languageChangeErrorMessage: 'Terjadi Kesalahan Saat Memperbarui Mata Uang',
        currencyAdded: "Mata uang berhasil ditambahkan",
        currencyDelete: "Mata uang berhasil dihapus",
        Selectyourpreferredlanguage: "Pilih bahasa pilihan Anda",
    },
    selectProductStock: 'Pilih Produk',
    category: {
        category_list: {
            title: 'Kategori Produk'
        },
        add_category: {
            button: 'Kategori Baru',
            title: 'Tambahkan Kategori Baru'
        },
        edit_category: {
            title: 'Edit Kategori'
        },
        name: 'Nama Kategori',
        name_placeholder: 'Masukkan Nama Kategori',
        no_category: 'Tidak ada kategori tersedia'
    },
    staff: {
        add: 'Tambah Staf',
        edit: 'Edit Staf',
        access: {
            stock: 'Stok',
            add_product: 'Tambah produk baru',
            edit_product: 'Edit produk',
            delete_product: 'Hapus produk',
            view_capital_price: 'Lihat Harga Modal',
            add_category: 'Tambah kategori baru',
            edit_category: 'Edit kategori',
            delete_category: 'Hapus kategori',
            add_supplier: 'Tambah vendor baru',
            edit_supplier: 'Edit vendor',
            delete_supplier: 'Hapus vendor',
            add_customer: 'Tambah pelanggan baru',
            edit_customer: 'Edit pelanggan',
            delete_customer: 'Hapus pelanggan',
            add_staff: 'Tambah staf',
            edit_staff: 'Edit staf',
            delete_staff: 'Hapus staf',
            change_business_profile: 'Ubah profil bisnis',
            access_by_product_category: 'Akses berdasarkan Kategori Produk',
            no_category_message: 'Anda belum memiliki kategori yang ditambahkan. Silakan tambahkan kategori.',
            expenses: 'Pengeluaran',
            view_expenses: 'Lihat Pengeluaran',
            add_expenses: 'Tambah Pengeluaran',
            edit_expenses: 'Sunting Pengeluaran',
            delete_expenses: 'Hapus Pengeluaran',
            warehouse: 'Gudang',
            add_new_warehouse: 'Tambah Gudang Baru',
            edit_warehouse: 'Sunting Gudang',
            delete_warehouse: 'Hapus Gudang',
            transfer_warehouse: 'Pindahkan Gudang',
            transfer_warehouse_approval: 'Persetujuan Pindah Gudang',
            access_by_warehouse: 'Akses berdasarkan Gudang',
            no_warehouse_message: 'Anda belum menambahkan gudang apa pun. Silakan tambahkan daftar gudang.',
            purchase_order: 'Pesanan Pembelian',
            purchase_order_creation: 'Pembuatan Pesanan Pembelian',
            purchase_order_edit: 'Edit Pesanan Pembelian',
            purchase_order_cancel: 'Batalkan Pesanan Pembelian',
            purchase_order_reopen: 'Buka Kembali Pesanan Pembelian',
            purchase_order_receive: 'Penerimaan Pesanan Pembelian',
            sales_order: 'Pesanan Penjualan',
            sales_order_creation: 'Pembuatan Pesanan Penjualan',
            sales_order_edit: 'Edit Pesanan Penjualan',
            sales_order_cancel: 'Batalkan Pesanan Penjualan',
            sales_order_reopen: 'Buka Kembali Pesanan Penjualan',
            sales_order_receive: 'Pengiriman Pesanan Penjualan',
            purchase_order_approval: 'Persetujuan Pesanan Pembelian',
            sales_order_approval: 'Persetujuan Pesanan Penjualan',
            can_do_available_warehouse: "Gudang Tersedia",
            notification: 'Notifikasi',
            staffNotification: 'Aktifkan Notifikasi',
            assignee: "Penerima Tugas",
        },
        no_staff: 'Tidak ada staf tersedia.'
    },
    code: {
        title: 'Staf Baru Ditambahkan!',
        subtitle: 'Bagikan kode undangan di bawah ini untuk bergabung:',
        valid: 'Kode berlaku selama 48 jam',
        share: 'Bagikan di WhatsApp',
        copied: 'Disalin!',
        invalid: 'Kode tidak valid!'
    },
    history: {
        no_history: 'Tidak ada riwayat.',
        detail: {
            remove: 'Hapus Riwayat',
            confirm: 'Fitur ini akan mempengaruhi stok, riwayat, dan laporan yang ada.'
        },
        no_history_selected: "Tidak ada riwayat yang dipilih",
        select_history_hint: "Klik riwayat dari daftar untuk melihat detailnya",
        select_from_left: "Pilih dari panel kiri",
    },
    supplier: {
        add: {
            title: 'Tambah Vendor'
        },
        edit: {
            title: 'Edit Vendor'
        },
        new: 'Vendor Baru',
        no_supplier: 'Tidak ada vendor tersedia.',
        bank: {
            title: 'Detail Bank'
        },
        note: 'Catatan',
        form: {
            name: {
                label: 'Nama Vendor',
                placeholder: 'Masukkan Nama Vendor',
                placheolder_not_mandatory: 'Masukkan nama',
                error: {
                    required: 'Nama tidak boleh kosong'
                }
            },
            contact: {
                label: 'Nomor Kontak',
                placeholder: '91934554432',
                error: {
                    required: 'Nomor kontak tidak boleh kosong',
                    invalid: 'Nomor tidak valid. Harus menyertakan kode negara'
                }
            },
            bank_name: {
                label: 'Nama Bank',
                placeholder: 'Masukkan Nama Bank'
            },
            bank_account_name: {
                label: 'Nama Pemegang Rekening',
                placeholder: 'Masukkan Nama Pemegang Rekening'
            },
            bank_account_number: {
                label: 'Nomor Rekening',
                placeholder: 'Masukkan Nomor Rekening'
            },
            note: {
                label: 'Catatan',
                placeholder: 'Tambahkan Catatan'
            },
            openingBalance: {
                addBtn: 'Tambah Saldo Awal',
                label: 'Saldo Awal',
                placeholder: 'Masukkan Saldo Awal',
                error: {
                    negative: 'Saldo awal tidak boleh bernilai negatif'
                }
            }
        },
        choose: 'Pilih Vendor'
    },
    customer: {
        add: {
            title: 'Tambah Pelanggan'
        },
        edit: {
            title: 'Edit Pelanggan'
        },
        new: 'Pelanggan Baru',
        no_customer: 'Tidak ada pelanggan tersedia.',
        note: 'Catatan',
        form: {
            name: {
                label: 'Nama Pelanggan',
                placeholder: 'Masukkan Nama Pelanggan',
                placheolder_not_mandatory: 'Masukkan nama',
                error: {
                    required: 'Nama tidak boleh kosong'
                }
            },
            contact: {
                label: 'Nomor Kontak',
                placeholder: '91934554432',
                error: {
                    required: 'Nomor kontak tidak boleh kosong',
                    invalid: 'Nomor tidak valid. Harus menyertakan kode negara'
                }
            },
            address: {
                label: 'Alamat',
                placeholder: 'Masukkan Alamat'
            },
            note: {
                label: 'Catatan',
                placeholder: 'Tambahkan Catatan'
            },
            openingBalance: {
                addBtn: 'Tambah Saldo Awal',
                label: 'Saldo Awal',
                placeholder: 'Masukkan Saldo Awal',
                error: {
                    negative: 'Saldo awal tidak boleh bernilai negatif'
                }
            }
        },
        choose: "Pilih Pelanggan",
        report: {
            view: 'Lihat Laporan Pembeli',
            title: 'Laporan Pelanggan',
            no_report: 'Tidak ada laporan untuk pembeli pada tanggal yang dipilih.',
            column: {
                name: 'Nama',
                total_transaction: 'Total Transaksi',
                total_amount: 'Total Penjualan',
                total_profit: 'Total Keuntungan'
            }
        }
    },
    confirm_delete: 'Apakah Anda yakin ingin menghapus data ini?',
    report: {
        title: 'Laporan'
    },
    accounting: {
        download_pdf_report: 'Unduh PDF',
        title: 'Akuntansi',
        view_report: 'Lihat Laporan Keuangan',
        dashboard_title: 'Laporan Keuangan',
        stats: 'Statistik',
        accounting_report: 'Laporan Akuntansi',
        filter: {
            date: {
                placeholder: 'Pilih Tanggal',
                submit: 'Terapkan',
                cancel: 'Reset Filter'
            },
            timeframe: {
                day: 'Harian',
                week: 'Mingguan',
                month: 'Bulanan',
                year: 'Tahunan'
            }
        },
        total_sales: 'Total Penjualan',
        total_purchases: 'Total Pembelian',
        total_profit: 'Total Keuntungan',
        total_expenses: 'Total Pengeluaran',
        assets_value: 'Nilai Aset Saat Ini',
        total_cogs: 'Total HPP',
        total_current_cogs_value: 'Total Nilai HPP Saat Ini',
        current_asset_selling_price: 'Nilai Jual Aset Saat Ini',
        total_selling_price: 'Total Harga Jual',
        table: {
            date: 'Tanggal',
            sales: 'Penjualan',
            purchases: 'Pembelian',
            profit: 'Keuntungan',
            expenses: 'Pengeluaran'
        },
        no_data: 'Tidak ada data tersedia.'
    },
    stock_report: {
        title: 'Laporan Stok',
        view: 'Lihat Laporan Stok',
        no_report: 'Tidak ada catatan stok untuk tanggal atau staf yang dipilih.',
        allStaffPlaceHolder: 'Semua Staf',
        column: {
            total_product: 'Jenis Produk Saat Ini',
            total_product_quantity: 'Total Produk Saat Ini'
        }
    },
    subscription: {
        paywall_small: {
            title: 'Fitur VIP',
            description:
                'Periode uji coba Anda untuk fitur ini telah berakhir. Dukung pengembangan aplikasi lokal ini dengan berlangganan.',
            button: 'Lihat Paket Langganan'
        }
    },
    payment: {
        order: {
            title: 'Pembayaran'
        }
    },
    imageUploadMessage: {
        uploadSize: 'Ukuran gambar tidak boleh melebihi 5MB!',
        failedMessage: 'Gagal mengunggah gambar item, silakan coba lagi!',
        successUpload: 'Gambar berhasil diunggah!',
        failedUIError: 'Gagal menghapus gambar, silakan coba lagi!',
        SuccessErrorImage: 'Gambar berhasil dihapus!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Nama Produk',
        categoryLabel: 'Kategori',
        BuyingPriceLabel: 'Harga Beli',
        SellingLabel: 'Harga Jual',
        StockLabel: 'Stok'
    },
    historyColumns: {
        Transactionlabel: 'Jenis Transaksi',
        Locallabel: 'Waktu Lokal',
        Createdlabel: 'Dibuat Oleh',
        Vendorlabel: 'Nama Vendor',
        Buyerlabel: 'Nama Pembeli',
        SKUlabel: 'SKU',
        Invoicelabel: 'Faktur',
        Productlabel: 'Nama Produk',
        Categorylabel: 'Kategori',
        Buyinglabel: 'Harga Beli',
        Sellinglabel: 'Harga Jual',
        Initiallabel: 'Stok Awal',
        Finallabel: 'Stok Akhir',
        Stocklabel: 'Perubahan Stok'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Nama Produk',
        categoryLabel: 'Kategori',
        buyingPriceLabel: 'Harga Beli',
        sellingPriceLabel: 'Harga Jual',
        stockInLabel: 'Stok Masuk',
        stockOutLabel: 'Stok Keluar',
        remainingStockLabel: 'Sisa Stok',
        openStockLabel: 'Stok Awal',
        weightedAverageCost: 'Biaya Rata-rata Tertimbang',
        weightedAverageCostLabel: 'Biaya Rata-rata Tertimbang',
        weightedAverageValueLabel: 'Nilai Rata-rata Tertimbang'
    },
    accountingReportColumns: {
        dateRange: 'Rentang Tanggal',
        reportingPeriod: 'Periode Laporan',
        reportGenerate: 'Laporan Dibuat',
        warehouse: 'Gudang',
        labelDate: 'Tanggal',
        labelSales: 'Penjualan',
        labelPurchases: 'Pembelian',
        labelProfit: 'Keuntungan',
        labelExpenses: 'Pengeluaran',
        reportOptions: 'Kolom Laporan',
        summaryCards: 'Kartu Ringkasan',
        grandTotal: 'Total Keseluruhan',
        continued: 'lanjutan',
        subtotal: 'Subtotal',
        page: 'Halaman'
    },
    customerReportColumns: {
        labelName: 'Nama',
        labelTotalTransaction: 'Total Transaksi',
        labelTotalSales: 'Total Penjualan',
        labelTotalProfit: 'Total Keuntungan'
    },
    scannerDialog: {
        finished: 'Selesai',
        reduce: 'Kurangi',
        successfull: 'Berhasil',
        searching: 'Mencari...',
        title: 'Pemindai aktif. Arahkan ke barcode!'
    },
    historyFilter: {
        SelectBuyer: 'Pilih Pembeli',
        SelectVendor: 'Pilih Vendor'
    },
    productStockFilter: {
        StockLowtoHigh: 'Stok Rendah ke Tinggi',
        StockHightoLow: 'Stok Tinggi ke Rendah',
        AlphabetAZ: 'Abjad A-Z',
        AlphabetZA: 'Abjad Z-A'
    },
    minimizeTitle: 'Pemindai aktif',
    security_guarantee: {
        title: 'Keamanan Data Terjamin'
    },
    invoice: {
        invoicePlaceholder: 'Nomor Faktur',
        invoiceTitle: 'Faktur',
        manageInvoiceAddress: 'Kelola Alamat Faktur',
        selectOrManageAddresses: 'Pilih, edit, atau buat alamat faktur kustom',
        useBusinessProfileAddress: 'Gunakan Alamat Profil Bisnis',
        noCustomAddressesFound: 'Tidak Ada Alamat Kustom Ditambahkan',
        createCustomAddressDesc: 'Tambahkan alamat tagihan atau cabang kustom untuk dicetak pada faktur Anda sebagai pengganti data profil bisnis default.',
        defaultFromBusinessProfile: 'Default Dari Profil Bisnis',
        editInvoiceAddress: 'Edit Alamat Faktur',
        createNewInvoiceAddress: 'Buat Alamat Faktur Baru',
        logoHeaderImage: 'Logo / Gambar Header',
        deleteInvoiceAddress: 'Hapus Alamat Faktur?',
        deleteAddressConfirmText: 'Apakah Anda yakin ingin menghapus alamat faktur ini? Tindakan ini tidak dapat dibatalkan.'
    },
    ManageInvoiceAddress: 'Kelola Alamat Faktur',
    SelectOrManageAddresses: 'Pilih, edit, atau buat alamat faktur kustom',
    UseBusinessProfileAddress: 'Gunakan Alamat Profil Bisnis',
    CreateNewAddress: 'Buat Alamat Baru',
    UpdatingList: 'Memperbarui daftar...',
    NoCustomAddressesFound: 'Tidak Ada Alamat Kustom Ditambahkan',
    CreateCustomAddressDesc: 'Tambahkan alamat tagihan atau cabang kustom untuk dicetak pada faktur Anda sebagai pengganti data profil bisnis default.',
    DefaultFromBusinessProfile: 'Default Dari Profil Bisnis',
    EditInvoiceAddress: 'Edit Alamat Faktur',
    CreateNewInvoiceAddress: 'Buat Alamat Faktur Baru',
    LogoHeaderImage: 'Logo / Gambar Header',
    UploadingImage: 'Mengunggah Gambar...',
    UploadImage: 'Unggah Gambar',
    BusinessName: 'Nama Bisnis',
    AddressDetails: 'Detail Alamat',
    PhoneNumber: 'Nomor Telepon',
    EmailAddress: 'Alamat Email',
    DeleteInvoiceAddress: 'Hapus Alamat Faktur?',
    DeleteAddressConfirmText: 'Apakah Anda yakin ingin menghapus alamat faktur ini? Tindakan ini tidak dapat dibatalkan.',

    stocklowreport: {
        no_stocklowreport_one: 'Tidak ada item dengan pengaturan Safety Stock.',
        no_stocklowreport_two: 'Silakan tambahkan jumlah Safety Stock.',
        currentStock: 'Stok Saat Ini',
        safetyStock: 'Stok Pengaman',
        pricing: 'Harga',
        costPrice: 'Harga Beli',
        sellingPrice: 'Harga Jual',
        productInfo: 'Informasi Produk',
        category: 'Kategori',
        description: 'Deskripsi',
        no_description: 'Deskripsi belum ditambahkan',
        variants: 'Varian',
        unitsOnHand: 'unit tersedia',
        minimumThreshold: 'batas minimum',
        adjust: 'Sesuaikan',
        all: 'Semua',
        lowStock: 'Stok Rendah',
        variantsDetails: 'Detail Varian',
        qty: 'Jumlah',
        addSafetyStock: 'Tambah Stok Pengaman',
        searchByNameSku: 'Cari berdasarkan Nama/SKU',
        safetyStockShort: 'P',
        warehouseSafetyStock: 'Stok Pengaman Gudang'
    },
    low_alert_stock: 'Masukkan jumlah safety stock',
    lowStockAlertNotify: 'Anda akan menerima notifikasi ketika stok turun di bawah jumlah yang ditetapkan',
    applyButtonStockAlert: 'Terapkan',
    cancelButtonStockAlert: 'Batal',
    searchProductLabel: 'Cari produk...',
    successfullyAddedSafetyStock: 'Safety Stock berhasil diperbarui',
    safety_Stock: 'Safety Stock',
    safety_stock_placeholder: 'Masukkan Safety Stock',
    lowStockDetailsInfo: {
        ProductCode: 'Kode Produk',
        SafetyStock: 'Safety Stock',
        Stock: 'Stok',
        CostPrice: 'Harga Beli',
        SellingPrice: 'Harga Jual',
        Category: 'Kategori',
        Description: 'Deskripsi',
        ExpirationDate: 'Tanggal Kedaluwarsa'
    },
    CustomLang: {
        Attribute: 'Atribut',
        AddAttribute: 'Tambah Atribut',
        EditAttribute: 'Edit Atribut',
        CustomLabePlaceholder: 'Masukkan Nama Atribut',
        CustomLabePlaceholderSelect: 'Pilih Tipe',
        AddMoreAttribute: 'Tambah Atribut Lain',
        ItemAttribute: 'Atribut Item',
        TableName: 'Nama',
        TableType: 'Tipe',
        TableAction: 'Aksi',
        TableDelete: 'Hapus',
        TableEdit: 'Edit',
        deleteMessage: 'Atribut berhasil dihapus',
        editSuccessMessage: 'Atribut berhasil diperbarui',
        AddSuccessMessage: 'Atribut berhasil ditambahkan',
        AddAtt: 'Tambah',
        EditAtt: 'Edit',
        SubmitAtt: 'Mengirim...'
    },
    Expenses: {
        ExpensesTitle: 'Pengeluaran',
        AddExpenses: 'Tambah Pengeluaran',
        ExpenseCategory: 'Kategori Pengeluaran',
        NoExpenseCategory: 'Tidak ada kategori pengeluaran',
        AddExpenseCategory: 'Tambah kategori pengeluaran',
        SelectExpenseCategory: 'Pilih kategori pengeluaran',
        NoExpenses: 'Tidak ada pengeluaran',
        ExpensesSuccess: 'Pengeluaran berhasil dibuat',
        ExpensesSuccessEdit: 'Pengeluaran berhasil diperbarui',
        ExpensesCategoryName: 'Nama kategori pengeluaran',
        ExpensesSuccessDelete: 'Pengeluaran berhasil dihapus',
        AddNEC: "Tambah Kategori Pengeluaran Baru",
        NC: "Kategori Pengeluaran Baru",
        EditNEC: "Edit Kategori Pengeluaran"
    },
    Manufacturing: {
        ProducedProduct: "Produk Hasil Produksi",
        QuantityManufactured: "Jumlah yang Diproduksi",
        UnitCost: "Biaya Satuan",
        RawMaterialsTotal: "Total Bahan Baku",
        TotalManufacturingCost: "Total Biaya Produksi",
        NoRawMaterialsConsumed: "Tidak ada bahan baku yang dikonsumsi.",
        CostBreakdown: "Rincian Biaya",
        GeneratedBatch: "Batch yang Dihasilkan",
        StoredBinLocation: "Lokasi Penyimpanan",
        NoManufacturingTransactionsFound: "Transaksi produksi tidak ditemukan",
        AddManufacture: 'Tambahkan Detail Produksi',
        Manufacturing: 'Produksi',
        RawMaterials: 'Bahan Baku',
        AdditonCosts: 'Biaya Tambahan',
        RawMaterial: 'Bahan Baku',
        AdditonCost: 'Biaya Tambahan',
        TotalCost: 'Total Biaya',
        AddRawMaterial: 'Tambahkan bahan baku untuk',
        AddAdditonCost: 'Tambahkan biaya tambahan untuk',
        AddMore: 'Tambahkan lagi',
        Add: 'Tambah',
        Update: 'Perbarui',
        Updating: 'Mengirim...',
        ProductRequired: 'Produk wajib diisi',
        QuantityRequired: 'Jumlah wajib diisi',
        ChargeRequired: 'Biaya wajib diisi',
        EstimatedCostRequired: 'Perkiraan biaya wajib diisi',
        PurchasePriceRequired: 'Harga beli wajib diisi',
        SelectCharge: 'Pilih Biaya',
        EstimatedCost: 'Perkiraan Biaya',
        SelectProduct: 'Pilih Produk',
        Quantity: 'Jumlah',
        ManufactureDetails: 'Detail Produksi',
        BuyingPrice: 'Harga Beli',
        LabourCharge: 'Biaya Tenaga Kerja',
        ElectricityCost: 'Biaya Listrik',
        PackagingCharge: 'Biaya Pengemasan',
        LogisticCost: 'Biaya Logistik',
        OtherCharges: 'Biaya Lainnya',
        Save: 'Simpan Detail',
        PurchasePrice: 'Harga Beli',
        Date: 'Tanggal',
        For: 'Untuk',
        PurchaseRate: 'Harga Beli (Rate)',
        Scrolltoloadmore: 'Gulir untuk memuat lebih banyak...',
        Noproductsfound: 'Produk tidak ditemukan',
        ManufacturingQuantity: 'Jumlah Produksi',
        ManufactureAddedSuccess: 'Detail Produksi berhasil diperbarui'
    },
    Warehouses: {
        transferOrder: 'Pindahkan Item',
        AddTransferOrder: 'Tambah Transfer Item',
        NewWarehouse: 'Gudang Baru',
        newHead: 'Mulai mengelola beberapa gudang!',
        headTwo: 'Pantau dan kelola inventaris Anda di beberapa gudang dengan mudah',
        EnableWarehouse: 'AKTIFKAN GUDANG',
        EnableWarehouse2: 'Aktifkan Gudang',
        OrganizationPrimary: 'Gudang Utama Organisasi',
        Edit: 'Edit',
        AreEnableWarehouse: 'Apakah Anda yakin ingin mengaktifkan gudang?',
        Confirm: 'Konfirmasi',
        Cancel: 'Batal',
        WarehouseCreatedSuccessfully: 'Gudang berhasil dibuat',
        MarkAsOP: 'Tandai sebagai Gudang Utama Organisasi',
        MarkAsInAct: 'Tandai sebagai Tidak Aktif',
        MarkAsAct: 'Tandai sebagai Aktif',
        MarkedAsInactive: 'Gudang berhasil ditandai tidak aktif',
        MarkedAsActive: 'Gudang berhasil ditandai aktif',
        MarkedAsOP: 'Gudang berhasil ditandai aktif',
        WareDeletedSuccess: 'Gudang berhasil dihapus',
        SuccessfullyUpdatedWarehouse: 'Gudang berhasil diperbarui',
        SuccessfullyCreatedWarehouse: 'Gudang berhasil dibuat',
        EditWarehouse: 'Edit Gudang',
        AddWarehouse: 'Tambah Gudang',
        WarehouseNameIsRequired: 'Nama Gudang wajib diisi',
        EnterWarehouseName: 'Masukkan nama Gudang',
        EnterEmail: 'Masukkan email',
        EnterPhoneNumber: 'Masukkan nomor telepon',
        Location: 'Lokasi...',
        name: 'Nama Gudang',
        email: 'Email',
        phoneNumber: 'Nomor Telepon',
        location: 'Lokasi',
        ViewProducts: 'Lihat produk',
        PageTitle: 'Gudang',
        noWarehouse: "Tidak ada gudang yang cocok dengan pencarian Anda"
    },
    Assets: {
        headerTitle: 'Aset',
        addAssetMessage: "Tambahkan aset di sini. Untuk menugaskan aset ke staf, buka profil anggota staf.",
        addAsset: 'Tambah Aset',
        editAsset: 'Edit Aset',
        assetCode: 'Kode Aset',
        assetName: 'Nama Aset',
        assetCategory: 'Kategori Aset',
        assetType: 'Tipe Aset',
        serialNumber: 'Nomor Seri',
        location: 'Lokasi',
        condition: 'Kondisi',
        selectCondition: 'Pilih Kondisi',
        fair: 'Cukup',
        good: 'Baik',
        excellent: 'Sangat Baik',
        poor: 'Buruk',
        notes: 'Catatan',
        submit: 'Kirim',
        submitting: 'Sedang Mengirim...',
        noCategory: 'Tidak ada kategori',
        selectCategory: 'Pilih kategori',
        addAssetCat: 'Tambah Kategori Aset',
        addAssetCatName: 'Nama kategori aset',
        edit: 'Edit',
        status: 'Status',
        createdAt: 'Dibuat Pada',
        viewAsset: 'Lihat Aset',
        assignAsset: 'Tugaskan Aset',
        conditionRet: 'Kondisi (Saat dikembalikan)',
        searchSelectAssets: 'Cari/Pilih Aset',
        assetAssigned: 'Aset berhasil ditugaskan',
        assetReturned: 'Aset berhasil dikembalikan',
        selectAnAsset: 'Silakan pilih aset',
        action: 'Aksi',
        noAssetAssigned: 'Tidak ada aset yang ditugaskan',
        reAssigned: 'Tugaskan Ulang',
        assignedAssetsList: 'Daftar Aset yang Ditugaskan',
        viewHistory: "Lihat Riwayat",
        history: "Riwayat Aset",
        loadingHistory: "Memuat riwayat...",
        loadingMore: "Memuat lebih banyak...",
        dateTime: "Tanggal & Waktu",
        staff: "Staf",
        AssignedBy: "Ditugaskan oleh",
        assign: "TUGASKAN",
        return: "KEMBALIKAN",
        unknown: "TIDAK DIKETAHUI",
        noHistory: "Tidak ada riwayat untuk aset ini.",
        enterReturnNote: "Masukkan catatan untuk pengembalian",
        returnNote: "Catatan pengembalian",
        enterAssignNote: "Masukkan catatan untuk penugasan",
        assignNote: "Catatan penugasan",
        AddNAC: "Tambah Kategori Aset Baru",
        EditNAC: "Edit Kategori Aset",
        others: "Lainnya",
        BatchManagementDescription: "Lacak stok berdasarkan nomor batch dan tanggal kedaluwarsa. Memastikan urutan LIFO / FEFO yang akurat pada setiap stok keluar — tidak perlu pemilihan manual.",
        Expiryalerts: "Peringatan kedaluwarsa",
        Autonotifications: "Notifikasi otomatis",
        LIFOsorting: "Penyortiran LIFO / FEFO",
        Smartstockflow: "Alur stok cerdas",
        Perout: "Stok keluar per batch",
        Precisiontracking: "Pelacakan presisi"
    },
    LedgerTransaction: {
        ledgerDetails: 'Detail Buku Besar',
        productName: 'Nama Produk',
        totalQty: 'Total Jumlah',
        date: 'Tanggal',
        receivedAmt: 'Jumlah Diterima',
        paid: 'Dibayar',
        discount: 'Diskon',
        balance: 'Saldo',
        more: 'Lainnya',
        total: 'Total',
        ledgerupdatedsuccessfully: 'Buku besar berhasil diperbarui',
        ledgeraddedsuccessfully: 'Buku besar berhasil ditambahkan',
        viewLedger: 'Lihat Buku Besar',
        edit: 'Edit',
        create: 'Buat',
        Recieved: 'Diterima [stok masuk]',
        payMode: 'Metode Pembayaran',
        Refno: 'No. Referensi'
    },
    ExtraField: {
        attachment: 'Lampiran',
        acceptOnlyImg: 'Hanya menerima gambar.',
        addAttribute: 'Tambah Atribut',
        acceptImgAndDoc: 'Terima gambar dan dokumen.'
    },
    phoneInvoiceDownload: {
        Variant: "Varian",
        Warehouse: "Gudang",
        Bin: "Bin",
        Batch: "Batch",
        Attributes: "Atribut"
    },
    ImportExcel: {
        ImportStockfromExcel: "Impor Stok dari Excel",
        DragDrop: "Seret & lepas file Excel yang sudah diisi di sini, atau klik untuk browse",
        DT: "Unduh Template",
        GB: "Kembali",
        Downloading: "Mengunduh...",
        ChangeFile: "Ganti File",
        ReadingExcelfile: "Membaca file Excel...",
        Processing: "Memproses...",
        submitUpdateStock: "Kirim & Perbarui Stok",
        downloadLatestTemplate: "Unduh Template Terbaru",
        loginRequired: "Login Diperlukan"
    },
    stockForm: {
        recordPaymentNow: "Catat pembayaran sekarang",
        recordPaymentDescCustomer: "Masukkan jumlah yang dibayar pelanggan",
        recordPaymentDescSupplier: "Masukkan jumlah yang dibayar pemasok",
        managePayments: "Kelola pembayaran",
        invoice: "Faktur",
        challan: "Surat jalan",
        recordPayment: "Catat pembayaran",
        payableAmount: "Jumlah yang harus dibayar",
        paidAmount: "Jumlah yang dibayar",
        paymentMethod: "Metode pembayaran",
        paymentDate: "Tanggal pembayaran",
        reference: "Referensi",
        billId: "Nomor tagihan",
        importExcel: "Impor dari Excel",
        noThanks: "Tidak, terima kasih",
        checkHistory: "Lihat riwayat",
        wantViewHistory: "Apakah Anda ingin melihat riwayat?",
        enterPayable: "Masukkan jumlah yang harus dibayar",
        enterPaid: "Masukkan jumlah yang dibayar",
        selectPayment: "Pilih metode pembayaran",
        attachment: "Lampiran",
        note: "Catatan"
    },
    HistoryEdit: {
        products: "Produk",
        add_product: "Tambah produk",
        paidAmountInvalidMessage: "Jumlah yang dibayar tidak boleh lebih besar dari jumlah yang harus dibayar",
        removingText: "Menghapus produk ini akan membatalkan perubahan stok yang dilakukan selama transaksi ini.",
        remove: "Hapus"
    },
    ExcelProduct: {
        uploadFile: "Unggah file",
        dragDrop: "Seret dan lepas file Excel Anda atau klik untuk mengunggah.",
        parsingFile: "Mengurai file",
        fileSelected: "File dipilih",
        reviewImportedData: "Tinjau data yang diimpor di bawah ini. Kolom dicocokkan secara otomatis jika memungkinkan.",
        changeFile: "Ganti file",
        back: "Kembali",
        invalidFileType: "Silakan unggah file Excel yang valid (.xlsx atau .xls)",
        parseExcelError: "Kesalahan parsing Excel:",
        noData: "File Excel yang diunggah tidak memiliki data.",
        failedToRead: "Gagal membaca file Excel. Silakan coba lagi.",
        Nodata: "TIDAK_ADA_DATA",
        unableToRead: "Tidak dapat membaca file.",
        buyingMustNumber: "Harga beli harus berupa angka",
        sellingMustNumber: "Harga jual harus berupa angka",
        mustBeNumber: "harus berupa angka",
        bulkUploadfailed: "Unggah massal gagal",
        importFromExcel: "Impor dari Excel",
        generating: "Menghasilkan...",
        downloadTemplate: "Unduh template",
        uploading: "Mengunggah...",
        done: "Selesai",
        requiredField: "{field} wajib diisi",
        bulkUpload: "Unggah massal",
        duplicateSku: "SKU duplikat ditemukan",
        uploadedSuccessfully: "Semua produk berhasil diunggah!",
        uploadCompleteIssues: "Unggahan selesai dengan masalah",
        uploaded_products: "{count} produk berhasil diunggah.",
        failed_products: "{count} gagal.",
        failed_items: "Item gagal:"
    },
    Discount: {
        overallDiscount: "Diskon keseluruhan",
        final: "Total akhir",
        balanceDue: "Sisa pembayaran",
        tax: "Pajak"
    },
    ProductForm: {
        barcodeQuantity: "Masukkan jumlah barcode",
        baseUnit: "Satuan dasar (utama)",
        addSecondaryUnit: "Tambahkan satuan sekunder?",
        selectUnit: "Pilih satuan",
        subUnitDetails: "Detail sub-satuan",
        subUnit: "Sub-satuan",
        selectSubUnit: "Pilih sub-satuan",
        conversionRate: "Tingkat konversi",
        exampleLogic: "Logika contoh:",
        example: "Jika Anda menjual pulpen dalam kotak, atur satuan dasar sebagai Kotak dan tambahkan sub-satuan (pcs) dengan konversi 50. Artinya 1 kotak berisi 50 pcs.",
        basePrice: "Harga dasar"
    },
    barcode: {
        settings: 'Pengaturan Barcode',
        labelSize: 'Ukuran label',
        customSize: 'Ukuran kustom...',
        widthMm: 'Lebar (mm)',
        heightMm: 'Tinggi (mm)',
        showPrice: 'Tampilkan harga jual pada label',
        noPrices: 'Tidak ada harga jual yang dikonfigurasi untuk produk ini.',
        preview: 'Pratinjau',
        generate: 'Buat',
        label: 'label',
        singlePage: 'Halaman Tunggal',
        downloadOptions: 'Opsi Unduh',
        chooseLayout: 'Pilih tata letak untuk barcode',
        allInSinglePage: 'Tambahkan semua barcode dalam satu halaman.',
        allInA4Grid: 'Semua dalam Halaman Tunggal',
        allInA4GridSub: 'Menyusun semua barcode dalam kisi A4',
        onePerPage: 'Satu Per Halaman',
        onePerPageSub: 'Setiap barcode pada halaman labelnya sendiri'
    },

    TransferItem: {
        transferItem: "Transfer item",
        Date: "Tanggal",
        Reason: "Alasan",
        enterReason: "Masukkan alasan",
        Name: "Nama",
        QuantityTransfered: "Jumlah dipindahkan",
        SWarehouse: "Gudang sumber",
        SelectSWarehouse: "Pilih gudang sumber",
        DWarehouse: "Gudang tujuan",
        SelectDWarehouse: "Pilih gudang tujuan",
        CreatedBy: "Dibuat oleh",
        CreatedTime: "Waktu dibuat",
        UpdatedTime: "Waktu diperbarui",
        NoOrderFound: "Tidak ada pesanan ditemukan",
        New: "Baru",
        WarehouseItemTransfer: "Transfer item gudang",
        TotalTransfers: "Total Transfer",
        EnterReason: "Masukkan alasan",
        ItemDetails: "Detail item",
        CurrentAvailable: "Ketersediaan saat ini",
        TransferQty: "Jumlah transfer",
        SStock: "Stok sumber",
        DStock: "Stok tujuan",
        addDescription: "Tambahkan deskripsi item",
        selectVariant: "Pilih varian",
        addNewRow: "Tambah baris baru",
        typeOrSelectItem: "Ketik untuk mencari",
        scrollToLoadMore: "Gulir untuk memuat lebih banyak",
        noProductsFound: "Produk tidak ditemukan",
        selectWarehouse: "Pilih gudang"
    },
    Sku: {
        searchSelectProduct: "Cari / pilih produk",
        searchSelectSku: "Cari / pilih SKU",
        noSkuFound: "SKU tidak ditemukan"
    },
    HistoryPage: {
        addFilter: "Tambah filter",
        filtersActive: "Semua filter aktif",
        noProducts: "Tidak ada produk",
        download: "Unduh",
        recentlyUpdated: "Baru diperbarui",
    },
    StockPage: {
        challanNumber: "Nomor Challan",
        subTotal: "Sub Total",
        totalTaxes: "Total & Pajak",
        taxInclusive: "Termasuk Pajak",
        discountedValue: "Nilai Diskon",
        taxValue: "Nilai Pajak",
        totalAmount: "Jumlah Total",
        close: "Tutup",
        addTax: "Tambah Pajak",
        label: "Label",
        enterLabel: "Masukkan label",
        taxRate: "Tarif Pajak",
        enterTaxRate: "Masukkan tarif pajak",
        selectTaxRate: "Pilih tarif pajak",
        addNewTax: "Tambah tarif pajak baru",
        discountProducts: "Nilai Diskon (Produk)",
        taxProducts: "Nilai Pajak (Produk)",
        clickAddPayment: "Klik untuk menambah pembayaran",
        paidGreaterPayable: "Jumlah dibayar tidak boleh lebih besar dari jumlah yang harus dibayar",
        vendorCompulsory: "Vendor wajib untuk mencatat pembayaran",
        customerCompulsory: "Pelanggan diperlukan untuk mencatat pembayaran",
        updateInvoiceFormat: "Perbarui format faktur",
        updateChallanFormat: "Perbarui format challan",
        addPrefix: "Tambah awalan",
        prefix: "Awalan"
    },
    EditHistoryPage: {
        search_by_notes: "Cari berdasarkan catatan",
        alertMessage: "Perubahan ini hanya dicatat dalam riwayat dan tidak memengaruhi stok saat ini.",
        paymentDetails: "Detail pembayaran",
        units: "Unit",
        customLabels: "Label kustom",
        value: "Nilai",
        Order_Info: "Info Pesanan",
        percentage: "Persentase",
        Stock_updates_on_submit: "Perbarui stok saat submit",
        Summary: "Ringkasan"
    },
    historyCard: {
        paid: "DIBAYAR",
        partiallyPaid: "DIBAYAR SEBAGIAN",
        billDate: "Tanggal tagihan",
        productDetails: "Detail produk",
        paymentsHistory: "Riwayat pembayaran",
        updatePayment: "Perbarui pembayaran",
        discounts: "Diskon",
        inclusive: "(termasuk)",
        discountOverall: "Nilai Diskon (Keseluruhan)",
        dueAmount: "Jumlah terutang",
        enterPaid: "Masukkan jumlah dibayar",
        enterReference: "Masukkan referensi",
        enterNote: "Masukkan catatan",
        enterInvoice: "Masukkan faktur",
        enterChallan: "Masukkan challan",
        edit: "Diedit"
    },
    printInvoice: {
        billTo: "Tagih ke",
        ref: "No. Ref",
        mode: "Mode",
        date: "Tanggal",
        amount: "Jumlah",
        totalPaid: "Total dibayar"
    },
    Contact: {
        supplier_required: "Pemasok diperlukan untuk stok masuk",
        customer_required: "Pelanggan diperlukan untuk stok keluar",
        key: "Kunci",
        editHistory: "Edit riwayat",
        loading: "Memuat..."
    },
    AW: {
        availablewarehouse: "Gudang Tersedia",
        visibilityManagement: 'Manajemen Visibilitas',
        availablewarehouses: "Gudang Tersedia",
        Active: "Aktif",
        LWarehouse: "Memuat Gudang...",
        NWForthisProduct: "Tidak ada gudang yang ditemukan untuk produk ini.",
        of: "dari",
        WarehouseAvailabilty: "Ketersediaan Gudang",
    },
    Currency: {
        searchCurrency: "Cari Mata Uang...",
        addCurrency: "Tambah Mata Uang",
        addNewCurrency: "Tambah Mata Uang Baru",
        editCurrency: "Edit Mata Uang",
        currencySymbol: "Simbol Mata Uang",
        currencyName: "Nama Mata Uang",
        enterCurrencySymbol: "Masukkan Simbol Mata Uang",
        enterCurrencyName: "Masukkan Nama Mata Uang"
    },
    NewReportLang: {
        DM: "Pergerakan Harian",
        WR: "Laporan Gudang",
        PDM: "Pergerakan Harian Produk",
        TBP: "Total Harga Beli",
        TPQ: "Total Kuantitas Produk",
        TP: "Total Produk",
        CS: "Stok Saat Ini",
        IV: "Nilai Inventaris",
        DA: "Rata-rata Harian",
        TSI: "Total Stok Masuk",
        TSO: "Total Stok Keluar",
        TOR: "Tingkat Perputaran",
        Tv: "Total Nilai",
        AST: "Pelacakan SKU Aktif",
        UT: "Unit Terlacak",
        SL: "Tingkat Stok",
        Value: "Nilai",
        IO: "MASUK/KELUAR",
        T: "Perputaran",
        unitsD: "Unit/Hari",
        Sort: "Urutkan",
        Sort_by: "Urutkan berdasarkan",
        Units_available: "Unit Tersedia",
        Units_unavailable: "Unit Tidak Tersedia",
        Current_assets: "Aset Lancar",
        Search: "Cari",
        available: "Tersedia",
        assigned: "Ditugaskan",
        AYSWD: "Apakah Anda yakin ingin menghapus?",
        PTS: "Gudang berhasil ditransfer",
        AUS: "Aset berhasil diperbarui",
        ACS: "Aset berhasil dibuat",
        VSP: "Lihat harga jual",
        HUS: "Riwayat berhasil diperbarui",
    },
    ReplacementReturn: {
        selectProduct: "Silakan pilih produk",
        selectReplacementProduct: "Pilih setidaknya satu produk pengganti",
        validQuantity: "Masukkan jumlah pengembalian yang valid",
        replacedSuccessfully: "Produk berhasil diganti",
        returnSuccessfully: "Produk berhasil dikembalikan",
        failedProcess: "Gagal memproses. Silakan coba lagi.",
        return: "Kembalikan",
        replace: "Ganti",
        typeSelectProduct: "Ketik atau pilih produk...",
        returnQuantity: "Jumlah Pengembalian",
        enterQuantity: "Masukkan Jumlah",
        replacementDate: "Tanggal Penggantian",
        returnDate: "Tanggal Pengembalian",
        chooseCustomer: "Pilih Pelanggan",
        additionalNotes: "Tambahkan catatan tambahan...",
        replacementProducts: "Produk Pengganti",
        addProducts: "Tambah Produk Lain",
        tapSelect: "Ketuk untuk memilih dari produk yang tersedia",
        currently: "Saat ini",
        item: "item",
        items: "item",
        selected: "dipilih",
        selectedItems: "Item yang dipilih",
        hideDetails: "Sembunyikan detail lebih lanjut",
        showDetails: "Tampilkan detail lebih lanjut",
        product: "produk",
        priceLevel: "Pilih tingkat harga",
        customPrice: "Masukkan harga khusus",
        noReplaceHistory: "Tidak ada riwayat penggantian yang ditemukan",
        replaceReturn: "Ganti dan Kembalikan",
        replaceReturnHistory: "Riwayat Penggantian & Pengembalian"
    },
    OtherComponent: {
        mfgHistoryTitle: "Riwayat Pembuatan",
        mfgHistoryDesc: "Lacak produk stok yang diproduksi",
        dailyOperation: "Operasi Harian",
        freqUsed: "Tindakan yang sering digunakan untuk memperbarui catatan dengan cepat",
        manageCategory: "Kelola Kategori",
        organizeCaterory: "Atur dan kelola kategori produk, pengeluaran, dan aset",
        businessRecord: "Catatan Bisnis",
        organizeRecord: "Atur dan kelola catatan bisnis Anda",
        trackHistory: "Lacak Riwayat",
        completeTracking: "Riwayat lengkap untuk audit dan pelacakan",
        Verifyinventorycount: "Verifikasi jumlah inventaris",
        Exchangerates: "Kurs tukar",
        Productiontracking: "Pelacakan produksi",
        Fixedassetregister: "Register aset tetap",
        Storagelocations: "Lokasi penyimpanan",
        warehouseAvailability: 'Ketersediaan produk tingkat gudang',
        Logreviewspend: "Catat & tinjau pengeluaran",
        Productgroupings: "Pengelompokan produk",
        Classifyexpenditures: "Klasifikasikan pengeluaran",
        Assetclassification: "Klasifikasi aset",
        Manageexchanges: "Kelola pertukaran",
        Returnauditlog: "Log audit pengembalian",
        Interlocationmoves: "Perpindahan antar lokasi",
        Manageoperationscategoriesrecordsandhistory: "Kelola operasi, kategori, catatan dan riwayat"
    },
    no_permission_dialog: {
        title: 'Tidak Ada Izin',
        historyDescription: "Anda tidak memiliki izin untuk melihat Riwayat Transaksi. Silakan hubungi administrator Anda.",
        replacementHistoryDescription: "Anda tidak memiliki izin untuk melihat Riwayat Penggantian & Pengembalian. Silakan hubungi administrator Anda.",
        transferHistoryDescription: "Anda tidak memiliki izin untuk melihat Riwayat Transfer Gudang. Silakan hubungi administrator Anda."
    },
    OthersHistory: {
        title: "Kelola Riwayat",
        transferHistory: "Kelola Riwayat Transfer",
        transactionHistory: "Kelola Riwayat Transaksi",
        replacementHistory: "Kelola Riwayat Penggantian dan Pengembalian"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Jelajahi dan beli produk yang dibagikan oleh bisnis.",
        description: "Jelajahi produk yang dibagikan oleh bisnis.",
        productsAvailable: "Produk Tersedia",
        noImageAvailable: "Tidak ada gambar tersedia",
        productDetails: "Detail Produk",
        inStock: "tersedia",
        availableVariants: "Varian Tersedia",
        options: "opsi",
        orders: "Pesanan"
        ,
        searchProducts: "Cari produk...",
        noProductsFound: "Produk tidak ditemukan",
        tryDifferentKeyword: "Coba cari dengan kata kunci lain",
        variants: "Varian",
        stock: "Stok",
        cart: "Keranjang",
        products: "Produk",
        viewCart: "Lihat Keranjang",
        backToProducts: "Kembali ke Produk",
        yourCart: "Keranjang Anda",
        clear: "Hapus",
        cartEmpty: "Keranjang Anda kosong",
        cartEmptyDesc: "Jelajahi katalog dan tambahkan produk yang ingin Anda pesan.",
        browseProducts: "Jelajahi Produk",
        selectedItems: "Item Terpilih",
        itemInCart: "item di keranjang",
        itemsInCart: "item di keranjang",
        customerDeliveryDetails: "Detail Pelanggan & Pengiriman",
        fullName: "Nama Lengkap",
        enterFullName: "Masukkan nama lengkap Anda",
        deliveryAddress: "Alamat Pengiriman",
        addressPlaceholder: "Alamat jalan, gedung, kota, kode pos...",
        orderNote: "Catatan Pesanan (Opsional)",
        orderNotePlaceholder: "Instruksi khusus atau catatan pengiriman...",
        paymentMode: "Metode Pembayaran",
        subtotal: "Subtotal",
        items: "item",
        totalAmount: "Total",
        orderOnWhatsApp: "Pesan via WhatsApp 📲",
        orderPlaced: "Pesanan Berhasil Dibuat! 🎉",
        orderPlacedDesc: "Pesanan Anda telah dicatat dan WhatsApp telah dibuka.",
        continueShopping: "Lanjut Belanja 🛍️",
        cartEmptyTitle: "Keranjang Kosong",
        cartEmptyToast: "Silakan tambahkan produk sebelum checkout.",
        incompleteTitle: "Detail Belum Lengkap",
        incompleteToast: "Silakan isi semua kolom yang wajib diisi.",
        nameRequired: "Nama lengkap wajib diisi",
        addressRequired: "Alamat pengiriman wajib diisi",
        catalogUnavailable: "Katalog Tidak Tersedia",
        catalogUnavailableDesc: "Katalog ini sedang tidak aktif. Hubungi bisnis untuk informasi lebih lanjut.",
        invalidCatalogLink: "Tautan Katalog Tidak Valid 🚫",
        invalidCatalogDesc: "Halaman katalog ini kehilangan informasi yang diperlukan.",
        missing: "Hilang",
        catalogSlug: "Slug Katalog",
        goBackHome: "Kembali ke Beranda",
        inventoryManagement: "Manajemen Inventaris & Faktur 🚀 Simply",
        enter: "Masukkan",
        select: "Pilih",
        // Catalog Order translations
        catalogOrders: 'Pesanan Katalog',
        pending: 'Tertunda',
        converted: 'Dikonversi',
        cancelled: 'Dibatalkan',
        totalRevenue: 'Nilai Total',
        totalCatalogOrders: 'Total Pesanan Online',
        convertToSalesOrder: 'Ubah ke Pesanan Penjualan',
        date: 'Tanggal',
        status: 'Status',
        action: 'Tindakan',
        searchOrders: 'Cari pelanggan atau telepon...',
        noMatchingOrders: 'Pesanan yang cocok tidak ditemukan',
        noStatusOrders: 'Tidak ada pesanan {status} ditemukan',
        tryDifferentSearch: 'Coba cari dengan nama pelanggan atau nomor telepon yang berbeda.',
        noOrdersWithStatus: 'Saat ini tidak ada pesanan dengan status {status}.',
        noOrdersYet: 'Belum Ada Pesanan Katalog',
        noOrdersDescription: 'Pesanan yang dilakukan dari katalog online Anda akan muncul di sini.',
        guestCustomer: 'Pelanggan Tamu',
        item: 'Item',
        moreItems: '+{count} lagi',
        viewDetails: 'Lihat Detail',
        viewSalesOrder: 'Lihat Pesanan Penjualan',
        cancelOrder: 'Batalkan Pesanan',
        confirmCancelTitle: 'Batalkan Pesanan Katalog?',
        confirmCancelOrder: 'Apakah Anda yakin ingin membatalkan pesanan ini? Tindakan ini tidak dapat dibatalkan.',
        keepOrder: 'Tidak, Simpan Pesanan',
        confirmCancelAction: 'Ya, Batalkan Pesanan',
        orderNotFound: 'Pesanan Katalog Tidak Ditemukan',
        orderNotFoundDescription: 'Pesanan ini tidak dapat ditemukan atau Anda mungkin tidak memiliki izin untuk melihatnya.',
        backToCatalogOrders: 'Kembali ke Pesanan Katalog',
        placedOn: 'Dipesan pada',
        totalItems: 'Total Item',
        orderedProducts: 'Produk yang Dipesan',
        itemDetails: 'Detail Item',
        quantity: 'Jml',
        unitPrice: 'Harga Satuan',
        total: 'Total',
        variant: 'Varian',
        customerInformation: 'Informasi Pelanggan',
        additionalFields: 'Kolom Tambahan',
        fields: 'kolom',
    },
    stockNew: {
        Npay: "Belum ada produk yang ditambahkan",
        emptydesc: "Pilih produk dari katalog Anda dan masukkan jumlah masuk untuk mencatat stok.",
        tipText: "Tips: Anda juga bisa mengunggah file excel",
        OT: "Total Pesanan",
        Collapse: "Ciutkan"
    },
    deleteBulk: {
        Bulkoperation: "Operasi Massal",
        Applyproducts: "Terapkan tindakan pada beberapa produk",
        Bulkupload: "Unggah Massal",
        ImportCSVfile: "Impor produk melalui file Excel atau CSV",
        or: "atau",
        Bulkdelete: "Hapus Massal",
        Permanentlyallproducts: "Hapus semua produk secara permanen",
        IrrText: "Penghapusan massal tidak dapat dibatalkan. Ekspor cadangan terlebih dahulu jika diperlukan.",
        SeP: "Produk yang Dipilih",
        sP: "Pilih Produk",
        DA: "Hapus Semua",
        DP: "Hapus Produk",
        sL: "Pilih Semua",
        ASDE: "Apakah Anda yakin ingin menghapus semua produk kecuali",
        ASDAllP: "Apakah Anda yakin ingin menghapus semua produk?",
        ASD: "Apakah Anda yakin ingin menghapus",
        products: "produk",
        TACBU: "Tindakan ini tidak dapat dibatalkan.",
        LP: "Memuat produk...",
        FM: "Mengambil lebih banyak...",
        NPF: "Tidak ada produk ditemukan.",
        LMP: "Memuat lebih banyak produk..."
    },
    NewVariantModal: {
        Definevariantsassign: "Tentukan varian & tetapkan jumlah",
        Nothingallocated: "Tidak ada yang dialokasikan",
        Overallocated: "Dialokasikan berlebih",
        Fullyallocated: "Dialokasikan sepenuhnya",
        Overby: "Lebih dari",
        Allvariantsneedaname: "Semua varian perlu nama.",
        Reducequantities: "Kurangi jumlah.",
        Overallocatedby: "Dialokasikan berlebih sebesar",
        Quantitiesmustmatchthetotalavailability: "Jumlah harus sesuai dengan total ketersediaan.",
        Allocatequantitiesacrosswarehouses: "Alokasikan jumlah di seluruh gudang",
        Notfullydistributed: "Belum sepenuhnya didistribusikan:",
        remaining: "tersisa",
        Qty: "Jml",
        Inactive: "Tidak Aktif",
        left: "tersisa"
    },
    ProductFormNew: {
        BasicInfo: "Informasi Dasar",
        ProductImage: "Gambar Produk",
        Images: "Gambar",
        Pricing: "Harga",
        Everypriceneedsbothalabelandanamount: "Setiap harga memerlukan label dan jumlah",
        AddalabellikeWholesaleorRetailtoidentifythisprice: 'Tambahkan label seperti "Grosir" atau "Eceran" untuk mengidentifikasi harga ini',
        AddMultiplePrice: "Tambah Beberapa Harga",
        NoPhotosLetAiFind: "Tidak ada foto? Biarkan AI mencari gambar produk",
        AddProductImagesTitle: "Tambah Gambar Produk",
        ChooseHowToAddPhotos: "Pilih cara Anda ingin menambahkan foto untuk produk ini:",
        SearchWithAi: "Cari dengan AI",
        SearchWithAiDesc: "Cari & pilih gambar produk secara otomatis menggunakan AI",
        FilesFileExplorer: "File (Penjelajah File)",
        FilesFileExplorerDesc: "Pilih gambar langsung dari komputer Anda",
        AiProductImageFinder: "Pencari Gambar Produk AI",
        AiProductImageFinderDesc: "Cari & pilih gambar untuk produk Anda",
        TypeProductNamePlaceholder: "Ketik nama produk...",
        SearchForYourProduct: "Cari produk Anda",
        SearchForYourProductHint: `Coba nama merek atau produk, misal "Kirkland Minoxidil" atau "Rogaine foam"`,
        ImagesSelected: "gambar dipilih",
        AddSelected: "Tambahkan yang Dipilih"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Tentukan bidang kustom baru",
        AttributeName: "Nama Atribut",
        DataType: "Tipe Data",
        Noattributesfound: "Tidak ada atribut ditemukan",
        ManageAttributes: "Kelola Atribut",
        Editordeleteexistingattributes: "Edit atau hapus atribut yang ada",
        UpdateAttribute: "Perbarui Atribut",
        Saving: "Menyimpan..."
    },
    NewExpenses: {
        Noexpensesyet: "Belum ada pengeluaran",
        Addyourfirstexpensetostarttrackingyourspending: "Tambahkan pengeluaran pertama Anda untuk mulai melacak pengeluaran.",
        TOTALEXPENSES: "TOTAL PENGELUARAN",
        ENTRIES: "ENTRI",
        BYCATEGORY: "BERDASARKAN KATEGORI",
        Nocategoriestodisplay: "Tidak ada kategori untuk ditampilkan",
        DateanfTime: "Tanggal & Waktu"
    },
    PurchaseSales: {
        CancelOrder: "Batalkan Pesanan",
        ReopenOrder: "Buka Kembali Pesanan",
        Reopen: "Buka Kembali",
        ConfirmCancelOrder: "Apakah Anda yakin ingin membatalkan pesanan ini?",
        ConfirmReopenOrder: "Apakah Anda yakin ingin membuka kembali pesanan ini?",
        OrderCancelledSuccessfully: "Pesanan berhasil dibatalkan.",
        OrderReopenedSuccessfully: "Pesanan berhasil dibuka kembali.",
        CancelledBy: "Dibatalkan Oleh",
        Cancelled: "Dibatalkan",
        ConvertPriceBasedOnUnitConversion: "Konversi Harga Berdasarkan Konversi Satuan",
        MarkPaymentAsPending: "Tandai Pembayaran sebagai Tertunda",
        PendingReceivableDesc: "Jumlah dicatat sebagai piutang. Catat pembayaran saat diterima.",
        PendingPayableDesc: "Jumlah dicatat sebagai utang. Catat pembayaran saat dibayar.",
        SelectCustomerFirst: "Pilih pelanggan terlebih dahulu",
        SelectSupplierFirst: "Pilih pemasok terlebih dahulu",
        SelectItemsFirst: "Silakan pilih setidaknya satu item terlebih dahulu",
        PaymentMarkedPendingDesc: "Pembayaran ditandai sebagai tertunda. Hapus centang 'Tandai Pembayaran sebagai Tertunda' untuk mencatat pembayaran sekarang.",
        SelectCustomerAndItemFirst: "Silakan pilih pelanggan dan setidaknya satu item terlebih dahulu",
        SelectSupplierAndItemFirst: "Silakan pilih pemasok dan setidaknya satu item terlebih dahulu",
        SelectCustomerProductFirst: "Pilih pelanggan & produk terlebih dahulu",
        SelectSupplierProductFirst: "Pilih pemasok & produk terlebih dahulu",
        Receivables: "Piutang",
        Payables: "Hutang",
        AccessDenied: "Akses Ditolak",
        YouDonthaeP: "Anda tidak memiliki izin untuk melihat halaman ini. Jika Anda merasa ini kesalahan, silakan hubungi administrator Anda.",
        purchase: "Pembelian",
        sales: "Penjualan",
        Areyousureyouwantto: "Apakah Anda yakin ingin",
        Thisactionwillupdateitsstatus: "Tindakan ini akan memperbarui statusnya.",
        ReasonOPtional: "Alasan (Opsional)",
        Enterareasonfor: "Masukkan alasan untuk",
        optionalDot: "(opsional)...",
        Reject: "Tolak",
        ConfirmOrder: "Konfirmasi Pesanan",
        RejectOrder: "Tolak Pesanan",
        Previous: "Sebelumnya",
        First: "Pertama",
        Order: "Pesanan",
        Items: "Item",
        Memo: "Memo",
        SelectDateRange: "Pilih Rentang Tanggal",
        List: "Daftar",
        Board: "Papan",
        View: "Tampilan",
        OrderType: "Tipe Pesanan",
        SelectOrderType: "Pilih Tipe Pesanan",
        CreateSalesOrder: "Buat Pesanan Penjualan",
        CreatePurchaseOrder: "Buat Pesanan Pembelian",
        successfully: "berhasil",
        ManageAttachments: "Kelola Lampiran",
        Stockoutitemsimmediatelyaftersaving: "Keluar stok item segera setelah menyimpan.",
        Stockinitemsimmediatelyaftersavingthisorder: "Masuk stok item segera setelah menyimpan pesanan ini.",
        ViewAttachments: "Lihat Lampiran",
        MemoAttachments: "Memo & Lampiran",
        ReceivedDate: "Tanggal Diterima",
        ShippedDate: "Tanggal Dikirim",
        OrderDate: "Tanggal Pesanan",
        OrderDetails: "Detail Pesanan",
        Subtotal: "Subtotal",
        OrderSummary: "Ringkasan Pesanan",
        AddItem: "Tambah Item",
        NewSalesOrder: "Pesanan Penjualan Baru",
        NewPurchaseOrder: "Pesanan Pembelian Baru",
        Createandmanageyour: "Buat dan kelola",
        orders: "pesanan Anda",
        Removeitem: "Hapus item",
        UnitPrice: "Harga Satuan",
        PurchaseOrder: "Pesanan Pembelian",
        SalesOrder: "Pesanan Penjualan",
        PurchaseInvoice: "Faktur Pembelian",
        SalesInvoice: "Faktur Penjualan",
        PurchaseOrdernotfound: "Pesanan Pembelian tidak ditemukan",
        Approve: "Setujui",
        MarkasShipped: "Tandai sebagai Dikirim",
        MarkasReceived: "Tandai sebagai Diterima",
        Marking: "Menandai...",
        PartiallyShip: "Pengiriman Sebagian",
        PartiallyReceive: "Penerimaan Sebagian",
        Deleting: "Menghapus...",
        Transaction: "Transaksi",
        Details: "Detail",
        Item: "Item",
        Received: "Diterima",
        Shipped: "Dikirim",
        Ordered: "Dipesan",
        units: "unit",
        Overalldiscount: "Diskon Keseluruhan",
        Transactions: "Transaksi",
        Notransactionsfound: "Tidak ada transaksi ditemukan",
        OrderedQty: "Jumlah Dipesan",
        Totalqty: "Total jumlah",
        StockingOut: "Mengeluarkan stok...",
        StockingIn: "Memasukkan stok...",
        thiorderUpdateStuau: "pesanan ini? Tindakan ini akan memperbarui statusnya.",
        TransactionDetails: "Detail Transaksi",
        Fetchingtransactiondetails: "Mengambil detail transaksi...",
        Nodetailsfoundforthistransaction: "Tidak ada detail untuk transaksi ini.",
        TotalBreakDown: "Rincian Total",
        ChangeAmount: "Jumlah Perubahan",
        Attachments: "Lampiran",
        PoNumber: "Nomor PO",
        SoNumber: "Nomor SO",
        partner: "Mitra",
        EditPurchase: "Edit Pembelian",
        EditSales: "Edit Penjualan",
        PurchaseOrderDetails: "Detail Pesanan Pembelian",
        SalesOrderDetails: "Detail Pesanan Penjualan",
        OrderTypePrepaid: "Prabayar",
        OrderTypeCOD: "Bayar di Tempat",
        OrderTypePayLater: "Bayar Nanti",
        OrderTypePartialPayment: "Pembayaran Sebagian",
        OrderTypeSubscription: "Langganan",
        viewAvailabilty: "Lihat Ketersediaan",
        NotReceived: "Belum Diterima",
        NotShipped: "Belum Dikirim",
        PartiallyReceived: "Diterima Sebagian",
        PartiallyShipped: "Dikirim Sebagian",
    },
    PriceReference: {
        HighPrice: "Harga Tinggi",
        LowPrice: "Harga Rendah",
        LastPrice: "Harga Terakhir",
        LastPurchasePrice: "Harga Pembelian Terakhir",
        Nopricerecordsfound: "Tidak ada catatan harga ditemukan",
        BuyingPriceReference: "Referensi Harga Beli",
        SellingPriceReference: "Referensi Harga Jual",
        Viewstockinpricesfortheselectedvendorandproduct: "Lihat harga masuk stok untuk vendor dan produk yang dipilih",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Lihat harga keluar stok untuk pelanggan dan produk yang dipilih"
    },
    SubscriptionLocale: {
        premiumPlan: "Paket Premium",
        heading: "Buat Keputusan Bisnis",
        headingHighlight: "Berdasarkan Data",
        subtitle: "Buka kekuatan penuh analitik bisnis Anda — tanpa batas, tanpa kompromi.",
        choosePlan: "Pilih paket Anda",
        monthly: "Bulanan",
        annual: "Tahunan",
        oneTime: "Sekali Saja (Bulannya)",
        perMonth: "per bulan",
        perYear: "per tahun",
        bestValue: "Nilai Terbaik",
        continueWith: "Lanjutkan dengan",
        perMonthShort: "bln",
        perYearShort: "thn",
        troubleWithSubscription: "Masalah dengan langganan?",
        contactUs: "Hubungi Kami",
        paymentNotReady: "Pembayaran belum siap",
        checkoutError: "ERROR CHECKOUT",
        pricePreviewError: "ERROR PRATINJAU HARGA",
        subNotAvailable: "Langganan tidak tersedia",
        subNotAvailableDesc: "Langganan web saat ini tidak tersedia di negara Anda. Silakan berlangganan melalui aplikasi seluler kami atau hubungi kami untuk bantuan."
    },
    SubscriptionLocale2: {
        GoPro: "Beralih ke Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Buat keputusan yang lebih cerdas didukung oleh data bisnis nyata",
        ExploreProPlans: "Jelajahi Paket Pro"
    },
    emptyWarehouseState: {
        tips: [
            "Anda dapat memiliki beberapa gudang untuk lokasi fisik yang berbeda",
            "Setiap produk melacak stok per gudang secara independen",
            'Gunakan "Transfer Gudang" untuk memindahkan stok antar lokasi'
        ],
        NoWarehousesConfigured: "Tidak Ada Gudang yang Dikonfigurasi",
        desc: "Mulai dengan menambahkan gudang Anda (jika Anda memiliki lebih dari satu), lalu lanjutkan untuk menambahkan produk dan mencatat pergerakan stok.",
        WarehouseSetupTips: "Tips Pengaturan Gudang",
        Noproductselected: "Tidak ada produk yang dipilih",
        Selectaproductfromthelefttoviewlowstockdetails: "Pilih produk dari sebelah kiri untuk melihat detail stok rendah.",
        Chooseaproductfromthelist: "Pilih produk dari daftar",
        SelectProduct: "Pilih Produk",
        SetQuantity: "Atur Jumlah",
        Showing: "Menampilkan",
        products: "produk",
        Continue: "Lanjutkan",
        SaveSafetyStock: "Simpan Stok Pengaman",
        SafetyStockSaved: "Stok Pengaman Tersimpan!",
        hasbeensetto: "telah diatur ke",
        AddAnother: "Tambahkan Lainnya",
        Chooseaproduct: "Pilih sebuah produk",
        Step: "Langkah",
        of: "dari",
        Setsafetyquantity: "Atur jumlah pengaman",
        Complete: "Selesai",
        SafetyStockQuantity: "Jumlah Stok Pengaman",
        Minimumunitsdropsbelowthisnumber: "Unit minimum yang harus selalu disimpan di stok. Peringatan akan muncul ketika stok turun di bawah angka ini.",
        NewSafetyStock: "Stok Pengaman Baru",
        SafetyNow: "Pengaman Sekarang",
        SettingTo: "Mengatur ke",
        Change: "Ubah",
        sell: "jual",
        cost: "biaya",
        BulUD: "Unggah/Hapus Massal"
    },
    SimplyLoginUI: {
        sslEncryption: "Enkripsi SSL 256-bit",
        dataPrivate: "Data Anda 100% pribadi",
        worksOnDevices: "Bekerja di Android & iPhone",
        realTimeSync: "Sinkronisasi real-time di semua perangkat",
        cloudBackup: "Backup cloud otomatis",
        availableOn: "Tersedia di Web, Android & iOS",
        tagline: "Inventaris Anda,",
        taglineEm: "sangat sederhana.",
        subtitle: "Masuk untuk mengelola stok, melacak penjualan, dan menjalankan bisnis Anda — semuanya di satu tempat.",
        feature1Title: "Pelacakan stok real-time",
        feature1Desc: "Tahu persis apa yang ada di setiap gudang, selalu terbaru.",
        feature2Title: "Pesanan penjualan & pembelian",
        feature2Desc: "Buat faktur, kelola vendor, dan lacak setiap transaksi.",
        feature3Title: "Laporan pintar",
        feature3Desc: "Laporan keuangan, stok, dan pergerakan harian dalam sekejap.",
        feature4Title: "Sinkronisasi real-time di semua perangkat",
        feature4Desc: "Perubahan di ponsel langsung muncul di web — dan sebaliknya.",
        rating1: "Dinilai",
        rating2: "4.9/5",
        rating3: "oleh 10.000 bisnis grosir",
        brandName: "Simply",
        greeting: "Halo lagi! 👋",
        noPasswordNeeded: "Masuk untuk mengakses inventaris Anda — Android, iPhone & web, semuanya tersinkron.",
        badge1: "Manajemen Stok",
        badge2: "Pelacakan Penjualan",
        badge3: "Laporan",
        trustEncryptedTitle: "Terenkripsi",
        trustEncryptedSub: "SSL 256-bit",
        trustPrivateTitle: "Pribadi",
        trustPrivateSub: "Hanya data Anda",
        trustBackedTitle: "Dicadangkan",
        trustBackedSub: "Otomatis harian",
        availableOnLabel: "TERSEDIA DI",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Semua perangkat sinkron secara instan secara real-time",
        securityNote: "100% aman.",
        securityDesc: "Enkripsi tingkat bank melindungi semua data Anda. Kami hanya membaca nama dan email Anda — tidak ada yang lain, selamanya.",
        signingIn: "Sedang masuk…",
        termsPrefix: "Dengan masuk, Anda menyetujui",
        privacyPolicy: "Kebijakan Privasi",
        and: "dan",
        termsOfService: "Syarat Layanan",
        google: "Masuk dengan Google"
    },
    BatchLocal: {
        BatchName: "Nama Batch",
        EnterBatchName: "Masukkan nama batch",
        EnterNotes: "Masukkan catatan",
        ExpiredDate: "Tanggal Kadaluarsa",
        Selectexpireddate: "Pilih tanggal kadaluarsa",
        BatchStatus: "Status Batch",
        CreatedDate: "Tanggal Dibuat",
        Areyousureyouwanttodeletethisbatch: "Apakah Anda yakin ingin menghapus batch ini?",
        Youhavencreatedanybatchforthisproduct: "Anda belum membuat batch apa pun untuk produk ini.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Buat batch pertama Anda untuk mulai melacak stok berdasarkan lot & tanggal kadaluarsa.",
        Nobatchesyet: "Belum ada batch",
        Whatisbatchmanagement: "Apa itu manajemen batch?",
        Howithelpsyourbusiness: "Bagaimana ini membantu bisnis Anda",
        Trackbylotnumber: "Lacak berdasarkan nomor lot",
        Trackbylotnumberdesc: "Kelompokkan stok berdasarkan batch produsen sehingga Anda selalu tahu unit berasal dari lot mana.",
        Expirydatecontrol: "Kontrol tanggal kadaluarsa",
        Expirydatecontroldesc: "Dapatkan peringatan sebelum stok kadaluarsa. Jual batch lama terlebih dahulu dan kurangi pemborosan secara otomatis.",
        Fulltraceability: "Pelacakan penuh",
        Fulltraceabilitydesc: "Lihat persis batch mana yang digunakan dalam setiap transaksi — sangat bagus untuk audit dan penarikan.",
        Supplierwisestock: "Stok berdasarkan pemasok",
        Supplierwisestockdesc: "Pisahkan stok dari pemasok berbeda meskipun produknya sama. Bandingkan kualitas batch per batch.",
        Createyourfirstbatchbutton: "Buat batch pertama Anda",
        Nomatchesfound: "Tidak ada yang cocok",
        NomatchesfounddescBefore: "Kami tidak menemukan batch yang cocok dengan ",
        NomatchesfounddescAfter: "",
        Clearsearch: "Hapus pencarian",
        Nohistoryfoundthisbatch: "Tidak ada riwayat untuk batch ini",
        ComprehensiveDetails: "Detail Lengkap",
        History: "Riwayat",
        InBatch: "Dalam Batch",
        Noproductfoundinthisbatch: "Tidak ada produk ditemukan dalam batch ini",
        SelectBatch: "Pilih Batch",
        available: "tersedia",
        Searchbatches: "Cari batch...",
        Expires: "Kadaluarsa",
        Nobatchesfound: "Tidak ada batch ditemukan",
        ManageBatches: "Kelola Batch",
        Batchmanagement: "Manajemen Batch",
        Trackstockexpiry: "Lacak stok berdasarkan batch & kadaluarsa",
        Turnoffbatchmanagement: "Matikan manajemen batch?",
        Yourgsafe: "Data batch yang sudah ada tetap aman.",
        Reenableanytimefrom: "Anda dapat mengaktifkannya kembali kapan saja dari",
        Otherstab: "tab Lainnya",
        AddBatch: "Tambah Batch",
        Total: "Total",
        AssignProduct: "Tetapkan Produk",
        EditProductAssignment: "Edit Penetapan Produk",
        AssignProducttoBatch: "Tetapkan Produk ke Batch",
        Updateproductconfiguration: "Perbarui konfigurasi produk",
        Step1of2: "Langkah 1 dari 2",
        Step2of2: "Langkah 2 dari 2",
        Selectvariantwarehouse: "Pilih varian & gudang",
        SelectedProduct: "Produk yang Dipilih",
        AssignQuantity: "Tetapkan Jumlah",
        BatchInfo: "Informasi Batch",
        Wecouldnthisproductidentifier: "Kami tidak menemukan batch yang terkait dengan identifier produk ini.",
        NoActiveBatches: "Tidak Ada Batch Aktif",
        Endofresults: "Akhir hasil",
        Expiry: "Kedaluwarsa",
        BatchManagementDescription: "Lacak stok berdasarkan nomor batch dan tanggal kedaluwarsa. Memastikan urutan LIFO / FEFO yang benar pada setiap stok keluar — tidak perlu pemilihan manual.",
        Expiryalerts: "Peringatan kedaluwarsa",
        Autonotifications: "Notifikasi otomatis",
        LIFOsorting: "Penyortiran LIFO / FEFO",
        Smartstockflow: "Aliran stok cerdas",
        Perout: "Stok keluar per batch",
        Precisiontracking: "Pelacakan presisi"
    },
    CategoryNewL: {
        TotalCategories: "Total Kategori",
        lastaddedcategory: "Kategori terakhir ditambahkan",
        acrossalltypes: "di semua jenis",
        MostRecent: "Terbaru",
        YesD: "Ya, Hapus",
        AllAssociated: "Semua produk terkait mungkin akan terpengaruh"
    },
    OverDas: {
        movestockbetweenlocations: "Pindahkan stok",
        no_activity_yet: "Belum ada aktivitas",
        no_activity_sub: "Penjualan, pembelian, pergerakan stok, dan retur akan muncul di sini secara real-time.",
        make_first_sale: "Lakukan Penjualan Pertama",
        add_stock: "Tambah Stok",
        all_stock_healthy: "Semua level stok sehat",
        all_stock_healthy_sub: "Tidak ada item yang hampir habis. Atur ambang batas minimum pada produk untuk mendapatkan alert di sini.",
        set_stock_thresholds: "Atur Ambang Batas Stok",
        no_warehouses_setup: "Belum ada gudang yang diatur",
        no_warehouses_setup_sub: "Tambahkan gudang untuk mulai melacak di mana stok Anda disimpan dan mengelola lokasi.",
        add_first_warehouse: "Tambah Gudang Pertama",
        Customer: "Pelanggan",
        PurchasevsSales: "Pembelian vs Penjualan",
        Financialperformancechart: "Grafik kinerja keuangan",
        QuickActions: "Aksi Cepat",
        Frequentlyused: "Sering digunakan",
        Addinventory: "Tambah inventori",
        Dispatchitems: "Kirim barang",
        Addorder: "Tambah order",
        Newitem: "Barang baru",
        Inventoryaccess: "Akses inventori",
        Itemsneedingreorder: "Barang yang perlu di-reorder",
        Latesttransactions: "Transaksi terbaru",
        Operationalsummary: "Ringkasan operasional",
        ViewAll: "Lihat Semua",
        Manage: "Kelola",
        RecentActivity: "Aktivitas Terbaru",
        LowStockAlerts: "Peringatan Stok Rendah",
        Primary: "Utama",
        TotalWarehouses: "Total Gudang"
    },
    SerialLocal: {
        ShowOrHideFields: "Tampilkan atau sembunyikan bidang",
        ShowOrHideFieldsDesc: "Ketuk item apa pun di bawah untuk menyertakan atau menghapusnya dari faktur yang dicetak. Perubahan langsung diterapkan.",
        Manufacturesettings: "Pengaturan manufaktur",
        Showbuyingprice: "harga beli / biaya produk",
        Showadditionalcost: "biaya tambahan",
        Costbreakdown: "Rincian biaya",
        Unitcost: "Biaya satuan",
        Rawmaterialstotal: "Total bahan baku",
        Confirmentry: "Konfirmasi entri",
        SaveSerials: "Simpan Nomor Seri",
        SerialNumber: "Nomor Seri",
        selected: "dipilih",
        added: "ditambahkan",
        Serialnumbers: "Nomor seri",
        ResetAll: "Reset Semua",
        Wecouldnfindthis: "Kami tidak dapat menemukan nomor seri yang tersedia untuk produk ini.",
        Nounitsfound: "Tidak ada unit ditemukan",
        Searchingserialnumbers: "Mencari nomor seri...",
        Scanorenterstock: "Pindai atau masukkan nomor seri untuk stok baru",
        Whataserialnumber: "Apa itu nomor seri?",
        Auniqueidentifieryourinventorylifecycle: "Identifier unik per unit — memungkinkan Anda melacak setiap item secara individu sepanjang siklus hidup inventaris.",
        Trackedstockout: "Stok keluar yang dilacak",
        Chooseexactlyselected: "Pilih secara tepat nomor serial mana yang keluar. Hanya serial yang sudah di-stok untuk produk ini yang ditampilkan — kuantitas akan terkunci setelah Anda memilih ",
        SelectSerialstoout: " - Pilih Nomor Seri untuk Keluar",
        Thisinvoicegeneratedusingwwwsimplstockco: "Faktur ini dibuat menggunakan www.simplstock.co",
        AuthorizedSignature: "Tanda Tangan Resmi",
        Invoicesettings: "Pengaturan Faktur",
        Draw: "Gambar",
        Taptoselectordeselectitems: "Ketuk untuk memilih atau membatalkan pilihan item",
        Thissignaturewillbeadded: "Tanda tangan ini akan ditambahkan di bagian bawah faktur cetak Anda.",
        SignatureOptions: "Opsi Tanda Tangan",
        Upload: "Unggah",
        DrawSignature: "Gambar Tanda Tangan",
        UploadSignature: "Unggah Tanda Tangan",
        Clear: "Hapus",
        ShowStaffName: "Nama Staf",
        ShowSKU: "SKU",
        ShowBusinessName: "Nama Bisnis",
        ShowProductName: "Nama Produk",
        ShowBusinessPhoneNumber: "Telepon",
        ShowBusinessEmail: "Email",
        ShowBusinessAddress: "Alamat",
        ShowProductImage: "Gambar Produk",
        ShowPaymentDetails: "Detail Pembayaran",
        ShowCategory: "Kategori",
        ShowVariant: "Varian",
        ShowWarehouse: "Gudang",
        ShowAttributes: "Atribut",
        ShowQuantity: "Kuantitas",
        ShowDiscount: "Diskon",
        ShowTax: "Pajak",
        ShowPrice: "Harga",
        ShowTotalPrice: "Total Harga Produk",
        ShowExpenses: "Biaya",
        ShowSignature: "Tanda Tangan",
        ShowNote: "Catatan",
        showAttachment: "Lampiran",
        ShowSerialNumber: "Nomor Seri",
        Invoicesettingsapplied: "Pengaturan faktur diterapkan. Periksa faktur untuk melihat perubahan.",
        EnterSerialNumber: "Masukkan Nomor Seri",
    },
    FewLocal: {
        SelectBin: "Pilih Bin",
        Live: "Live",
        Monitorinventorystocklevels: "Pantau inventori, pergerakan & tingkat stok",
        StockControlCentre: "Pusat Kontrol Stok",
        Nochartdataavailable: "Tidak ada data chart tersedia",
        Disabled: "Nonaktif",
        Enabled: "Aktif"
    },
    Bin: {
        Bin: "Bin",
        Add: "Tambah",
        NoBinsAddedYet: "Belum ada bin yang ditambahkan",
        BinLocationsHelp: "Lokasi bin membantu Anda melacak stok berdasarkan posisi pasti di dalam gudang ini — tidak perlu mencari lagi.",
        NameThemByPosition: "Beri nama berdasarkan posisi:",
        AddBinLocation: "Tambah Lokasi Bin",
        BinLocations: "lokasi bin",
        BinNameRequired: "Nama bin diperlukan",
        EditBin: "Edit Bin",
        AddBin: "Tambah Bin",
        EnterBinName: "Nama Bin",
        EnterBinNamePlaceholder: "Masukkan nama bin",
        BinStatus: "Status Bin",
        BinNotes: "Catatan",
        EnterBinNotesPlaceholder: "Tambahkan catatan...",
        ViewInventory: "Lihat Inventori",
        Inventory: "Inventori",
        TrymatchingadifferentSKUname: "Coba cocokkan SKU atau nama lain.",
        Thisbinlocationcurrentlyempty: "Lokasi bin ini saat ini kosong.",
        Loadingbins: "Memuat bin...",
        bins: "bin",
        ManageBin: "Kelola Bin",
        Print: "Cetak",
        SBin: "Bin Asal",
        DBin: "Bin Tujuan"
    },
    WarehouseExcel: {
        title: "Unggah Gudang & Lokasi Bin",
        description: "Ikuti langkah-langkah di bawah ini untuk membuat gudang secara massal beserta lokasi bin-nya menggunakan file Excel.",
        bulkUploadGuide: "Panduan Unggah Massal",
        step1: "Langkah 1",
        downloadTemplate: "Unduh template Excel",
        downloadTemplateDesc: "Dapatkan template resmi dengan semua header kolom yang diperlukan. Jangan ubah nama atau hapus kolom apapun.",
        downloadTemplateBtn: "Unduh Template",
        step2: "Langkah 2",
        fillExcelFile: "Isi file Excel",
        fillExcelDesc: "Setiap baris mewakili satu gudang. Isi semua kolom — untuk lokasi bin, masukkan semua nama bin dipisahkan koma di kolom <code>Bin Names</code>.",
        step3: "Langkah 3",
        thingsToKeepInMind: "Hal yang perlu diperhatikan",
        rulesDesc: "Sebelum mengunggah, pastikan file Anda mengikuti aturan ini agar tidak terjadi kesalahan.",
        step4: "Langkah 4",
        uploadYourFile: "Unggah file Anda",
        uploadDesc: "Setelah diisi, unggah file di bawah ini. Sistem akan membuat semua gudang dan lokasi bin secara otomatis.",
        rules: ["Satu baris per gudang saja", "Nama bin dipisahkan koma dalam satu sel", "Jangan ubah nama header kolom", "Nama bin duplikat per gudang akan dilewati", "Nomor telepon dengan kode negara", "Hanya file .xlsx atau .xls yang diterima"],
        dropFileHere: "Letakkan file Excel Anda di sini",
        supports: "Mendukung .xlsx dan .xls — maksimal 10 MB",
        chooseFileUpload: "Pilih File & Unggah",
        parsing: "Mengurai file...",
        invalidFileType: "Jenis file tidak valid. Silakan unggah file Excel.",
        noData: "Tidak ada data ditemukan di Excel",
        failedToRead: "Gagal membaca file Excel",
        unableToRead: "Tidak dapat membaca file.",
        reviewTitle: "Tinjau Data Gudang",
        reviewSubtitle: "Pemeriksaan akhir sebelum diimpor ke bisnis Anda.",
        changeFile: "Ganti File",
        rowsFound: "baris ditemukan di file",
        cancel: "Batal",
        finalizeImport: "Selesaikan & Impor",
        importing: "Mengimpor...",
        success: "Berhasil",
        allWarehouseUploadedSuccess: "Semua gudang berhasil diunggah",
        failed: "Gagal",
        bulkUploadFailed: "Unggah massal gagal",
        error: "Kesalahan",
        binNamesNote: "Di kolom <strong>Bin Names</strong>, masukkan semua lokasi bin untuk satu gudang dalam satu sel, dipisahkan koma — contoh: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Nama Gudang", email: "Email", phoneNumber: "Nomor Telepon", location: "Lokasi", binNames: "Nama Bin" }
    },
    VariantTemplate: {
        VariantTemplates: "Template Variasi",
        Managereusablevariantpatterns: "Kelola pola variasi yang dapat digunakan ulang",
        BinTransferHistory: "Riwayat Transfer Bin",
        Trackmovementsacrossbins: "Lacak pergerakan antar bin",
        SerialNumberHistory: "Riwayat Nomor Seri",
        Trackproductserialnumberactivity: "Lacak aktivitas nomor seri produk",
        Period: "Periode",
        Nohistoryfound: "Tidak ada riwayat ditemukan",
        Searchserialnumbers: "Cari nomor seri...",
        SerialNumbersHistory: "Riwayat Nomor Seri",
        Serialnumberhistoryglance: "Riwayat nomor seri sekilas.",
        Noserialnumbersfound: "Tidak ada nomor seri ditemukan",
        Noactivityhistoryfound: "Tidak ada riwayat aktivitas",
        Statussetto: "Status diubah menjadi",
        Timeline: "Timeline",
        Managereusableproductvariantpatterns: "Kelola pola variasi produk yang dapat digunakan ulang.",
        DeleteTemplate: "Hapus Template",
        Areyousureyouwanttemplate: "Apakah Anda yakin ingin menghapus template ini?",
        CreateNewTemplate: "Buat Template Baru",
        CreateTemplate: "Buat Template",
        EditTemplate: "Edit Template",
        UnlimitedTemplates: "Template tanpa batas",
        CreateAsManyTemplates: "Buat sebanyak yang Anda butuhkan — Pakaian, Sepatu, Elektronik, dan lainnya.",
        PickWhileAddingProduct: "Pilih saat menambahkan produk",
        OpenTemplateLibrary: "Buka pustaka template Anda dan pilih nama variasi dalam hitungan detik.",
        MixFromMultipleTemplates: "Gabungkan dari beberapa template",
        SelectFromMultipleTemplates: "Pilih nama variasi dari lebih dari satu template untuk satu produk — sepenuhnya fleksibel.",
        EditAnytime: "Edit kapan saja",
        RenameTemplatesAnytime: "Ganti nama template, tambah atau hapus nama variasi kapan pun katalog Anda berubah.",
        StayConsistent: "Tetap konsisten",
        SameVariantNamesAcrossAll: "Nama variasi yang sama di semua produk. Tidak ada typo, tidak ada duplikat, tidak ada tebakan.",
        BuildOnceUseEverywhere: "Buat sekali, gunakan di mana saja",
        StopReEnteringVariantNames: "Berhenti mengetik ulang nama variasi yang sama untuk setiap produk. Buat template, tetapkan nama variasi, dan gunakan kembali secara instan.",
        Updateexistingvariantcombinations: "Perbarui kombinasi variasi yang ada",
        Definenewvariantcombinations: "Tentukan kombinasi variasi baru",
        TemplateName: "Nama Template",
        AddVariantOptions: "Tambah Opsi Variasi",
        SmallMedium: "contoh: Small, Medium...",
        VariantsList: "Daftar Variasi",
        Nooptionsaddedyet: "Belum ada opsi yang ditambahkan",
        SaveTemplate: "Simpan Template",
        egSizesColorsetc: "contoh: Ukuran Kaos, Warna, dll.",
        Pleaseentertemplatename: "Mohon masukkan nama template",
        Pleaseaddatleastonevariantoption: "Mohon tambahkan setidaknya satu opsi variasi",
        Templateupdatedsuccessfully: "Template berhasil diperbarui",
        Templatecreatedsuccessfully: "Template berhasil dibuat",
        Failedtosavetemplate: "Gagal menyimpan template",
        Transfer: "Transfer",
        Editassignment: "Edit penugasan",
        Updateproductdetailsinbin: "Perbarui detail produk di bin",
        Editinginbin: "Sedang mengedit di bin",
        ConfirmUpdate: "Konfirmasi Pembaruan",
        ConfirmAssign: "Konfirmasi Penugasan",
        Assignanotherproduct: "Tugaskan produk lain",
        TransferBin: "Transfer Bin",
        SourceBin: "Bin Asal",
        DestinationBin: "Bin Tujuan",
        SelectSourceBin: "Pilih Bin Asal",
        SelectDestinationBin: "Pilih Bin Tujuan",
        Unit: "Satuan",
        ManageVariant: "Kelola Variasi",
        CreateSKUvariationsyourproduct: "Buat variasi SKU untuk produk Anda",
        Assigningvariationsto: "Menugaskan variasi ke",
        Novariantsaddedyet: "Belum ada variasi yang ditambahkan",
        AddedVariants: "Variansi yang Ditambahkan",
        AddVariantsfromTemplate: "Tambah Variasi dari Template",
        Pickatemplateandselectvariantnames: "Pilih template dan pilih nama variasi",
        ChooseaTemplate: "Pilih Template",
        Selectvariantnamestoadd: "Pilih nama variasi untuk ditambahkan",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Pilih template untuk mengambil nama variasi. Anda dapat menambahkan dari beberapa template.",
        Loadingtemplates: "Memuat template...",
        Backtotemplates: "Kembali ke template",
        Selectallindividualadd: "Pilih semua atau nama variasi individu untuk ditambahkan.",
        VariantNames: "Nama Variasi",
        MediaDescription: "Media & Deskripsi",
        Addattachmentsandproductnotes: "Tambahkan lampiran dan catatan produk",
        ProductMedia: "Media Produk"
    },
    AddProductGuide: {
        title: "Tambahkan jumlah awal setelah menyimpan",
        description: "Produk tidak memiliki kolom kuantitas di sini. Setelah disimpan, gunakan 'Stock In' untuk mencatat stok awal Anda — dengan kontrol penuh atas lokasi dan pelacakan.",
        steps: {
            quantity: { title: "Kuantitas", sub: "Atur jumlah stok awal" },
            binLocation: { title: "Lokasi Bin", sub: "Lorong, rak, rak — contoh: A-01-03" },
            serialNumbers: { title: "Nomor Seri", sub: "Lacak setiap unit secara individu" },
            warehouse: { title: "Gudang", sub: "Di lokasi mana disimpan" },
            batchExpiry: { title: "Batch / Kadaluarsa", sub: "Kelompokkan stok berdasarkan nomor batch" }
        },
        actions: { close: "Tutup" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Tidak Ada Order Transfer Ditemukan",
        Itemshistory: "Barang yang Anda transfer antar gudang akan muncul di sini untuk pelacakan dan riwayat.",
        CreateTransfer: "Buat Transfer"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Ketuk produk untuk Memproduksi",
        Selectproductfrombelow: "Pilih produk dari daftar di bawah",
        SetupANewProduct: "Siapkan Produk Baru",
        DefineAProductAdditsrawmaterial: "Tentukan Produk & Tambahkan bahan bakunya",
        ManufacturingSetup: "Pengaturan Produksi",
        Pickproducttodefineitsproductiondetails: "Pilih produk untuk menentukan detail produksinya",
        ConfigureManufacturing: "Konfigurasi Produksi",
        SelectRawMaterial: "Pilih Bahan Baku",
        NoRawMaterials: "Tidak Ada Bahan Baku",
        Definecomponentsneededtoproduct: "Tentukan komponen yang dibutuhkan untuk memproduksi produk ini.",
        NoAdditionalCosts: "Tidak Ada Biaya Tambahan",
        Addlaboroverheadlogisticalcharges: "Tambahkan biaya tenaga kerja, overhead, atau logistik.",
        AddAdditionalCost: "Tambah Biaya Tambahan",
        AddCost: "Tambah Biaya",
        TotalPrice: "Total Harga",
        SelectCharges: "Pilih Biaya",
        EnterEstimatedCost: "Masukkan Estimasi Biaya",
        QtyRequried: "Jumlah yang Dibutuhkan",
        Manufacturing: "Produksi",
        Outputfinishedgoodsdestination: "Tujuan barang jadi",
        Manufacturingquantity: "Jumlah produksi",
        Storefinishedgoodsat: "Simpan barang jadi di",
        Rawmaterials: "Bahan baku",
        StockSelection: "Pemilihan Stok",
        AdditionalCosts: "Biaya Tambahan",
        Quantityconsume: "Jumlah yang dikonsumsi",
        Totalmanufacturingcost: "Total biaya produksi",
        Sumofrawmaterialcosts: "Jumlah dari semua biaya bahan baku",
        CustomManufacturingCharge: "Biaya Produksi Kustom",
        Addextralikelaboroverheadrepairs: "Tambahkan biaya ekstra seperti tenaga kerja, overhead, atau perbaikan.",
        CalculatedTotal: "Total Terhitung",
        AddRawMaterial: "Tambah Bahan Baku",
        ConfigureRawMaterial: "Konfigurasi Bahan Baku",
        Thisoutputunit: "Ini adalah jumlah dasar yang dibutuhkan per unit output.",
        ChangeProduct: "Ganti Produk",
        AddtoList: "Tambah ke Daftar",
        ManufacturedSuccessfully: "Berhasil Diproduksi",
        Manufacture: "Produksi",
        EditDeleteHistory: "Edit Riwayat",
        ManageOrder: "Kelola Pesanan",
        ManageBatch: "Kelola Batch",
        Paymentnotavailablehere: "Pembayaran tidak tersedia di sini",
        Thisrecordisanorderorderitself: "Catatan ini berasal dari pesanan. Pembayaran hanya dapat dicatat dari pesanan itu sendiri.",
        Torecorpaymenttheorderthethere: "Untuk mencatat pembayaran, buka pesanan tertaut dan gunakan opsi <b>Catat Pembayaran</b> di sana.",
        GotoOrder: "Ke Pesanan"
    },
    CustomerExcel: {
        title: "Unggah Pelanggan",
        description: "Ikuti langkah-langkah di bawah ini untuk membuat pelanggan secara massal menggunakan file Excel.",
        bulkUploadGuide: "Panduan Unggah Massal",
        step1: "Langkah 1",
        downloadTemplate: "Unduh template Excel",
        downloadTemplateDesc: "Dapatkan template resmi dengan semua header kolom yang diperlukan yang telah dikonfigurasikan.",
        downloadTemplateBtn: "Unduh Template",
        step2: "Langkah 2",
        fillExcelFile: "Isi file Excel",
        fillExcelDesc: "Setiap baris mewakili satu pelanggan. Isi semua kolom sesuai kebutuhan.",
        step3: "Langkah 3",
        thingsToKeepInMind: "Hal yang perlu diperhatikan",
        rulesDesc: "Sebelum mengunggah, pastikan file Anda mengikuti aturan ini untuk menghindari kesalahan.",
        step4: "Langkah 4",
        uploadYourFile: "Unggah file Anda",
        uploadDesc: "Setelah diisi, unggah file di bawah ini. Sistem akan membuat semua pelanggan secara otomatis.",
        rules: [
            "Satu baris per pelanggan saja",
            "Jangan ubah nama header kolom",
            "Nomor kontak dengan kode negara",
            "Hanya file .xlsx atau .xls yang diterima"
        ],
        dropFileHere: "Letakkan file Excel Anda di sini",
        supports: "Mendukung .xlsx dan .xls — maksimal 10 MB",
        chooseFileUpload: "Pilih File & Unggah",
        parsing: "Mengurai file...",
        invalidFileType: "Jenis file tidak valid. Silakan unggah file Excel.",
        noData: "Tidak ada data ditemukan di Excel",
        failedToRead: "Gagal membaca file Excel",
        unableToRead: "Tidak dapat membaca file.",
        reviewTitle: "Tinjau Data Pelanggan",
        reviewSubtitle: "Pemeriksaan akhir sebelum diimpor ke bisnis Anda.",
        changeFile: "Ganti File",
        rowsFound: "baris ditemukan di file",
        cancel: "Batal",
        finalizeImport: "Selesaikan & Impor",
        importing: "Mengimpor...",
        success: "Berhasil",
        allCustomerUploadedSuccess: "Semua pelanggan berhasil diunggah",
        failed: "Gagal",
        bulkUploadFailed: "Unggah massal gagal",
        error: "Kesalahan",
        headers: {
            customerName: "Nama Pelanggan",
            phoneNumber: "Kontak",
            address: "Alamat",
            note: "Catatan"
        }
    },
    SupplierExcel: {
        title: "Unggah Vendor",
        description: "Ikuti langkah-langkah di bawah ini untuk membuat vendor secara massal menggunakan file Excel.",
        bulkUploadGuide: "Panduan Unggah Massal",
        step1: "Langkah 1",
        downloadTemplate: "Unduh template Excel",
        downloadTemplateDesc: "Dapatkan template resmi dengan semua header kolom yang diperlukan yang telah dikonfigurasikan.",
        downloadTemplateBtn: "Unduh Template",
        step2: "Langkah 2",
        fillExcelFile: "Isi file Excel",
        fillExcelDesc: "Setiap baris mewakili satu vendor. Isi semua kolom sesuai kebutuhan.",
        step3: "Langkah 3",
        thingsToKeepInMind: "Hal yang perlu diperhatikan",
        rulesDesc: "Sebelum mengunggah, pastikan file Anda mengikuti aturan ini untuk menghindari kesalahan.",
        step4: "Langkah 4",
        uploadYourFile: "Unggah file Anda",
        uploadDesc: "Setelah diisi, unggah file di bawah ini. Sistem akan membuat semua vendor secara otomatis.",
        rules: [
            "Satu baris per vendor saja",
            "Jangan ubah nama header kolom",
            "Nomor kontak dengan kode negara",
            "Hanya file .xlsx atau .xls yang diterima"
        ],
        dropFileHere: "Letakkan file Excel Anda di sini",
        supports: "Mendukung .xlsx dan .xls — maksimal 10 MB",
        chooseFileUpload: "Pilih File & Unggah",
        parsing: "Mengurai file...",
        invalidFileType: "Jenis file tidak valid. Silakan unggah file Excel.",
        noData: "Tidak ada data ditemukan di Excel",
        failedToRead: "Gagal membaca file Excel",
        unableToRead: "Tidak dapat membaca file.",
        reviewTitle: "Tinjau Data Vendor",
        reviewSubtitle: "Pemeriksaan akhir sebelum diimpor ke bisnis Anda.",
        changeFile: "Ganti File",
        rowsFound: "baris ditemukan di file",
        cancel: "Batal",
        finalizeImport: "Selesaikan & Impor",
        importing: "Mengimpor...",
        success: "Berhasil",
        allSupplierUploadedSuccess: "Semua vendor berhasil diunggah",
        failed: "Gagal",
        bulkUploadFailed: "Unggah massal gagal",
        error: "Kesalahan",
        headers: {
            supplierName: "Nama Vendor",
            phoneNumber: "Kontak",
            bankName: "Nama Bank",
            accountHolderName: "Nama Pemegang Akun",
            accountNumber: "Nomor Akun",
            note: "Catatan"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "Diganti Dengan",
        Noreplacementhistoryfound: "Riwayat penggantian tidak ditemukan",
        Noreturnhistoryfound: "Riwayat pengembalian tidak ditemukan",
        Productbeingreturned: "Produk yang dikembalikan",
        Required: "Wajib",
        Selectreturnedproduct: "Pilih produk yang dikembalikan",
        Searchnamescanbarcode: "Cari berdasarkan nama, SKU atau pindai barcode",
        Browse: "Cari",
        Stockhandling: "Penanganan stok masuk",
        Stockinreturnedproduct: "Stok masuk produk yang dikembalikan",
        Ontoinventory: "On — item yang dikembalikan akan ditambahkan kembali ke inventaris",
        Offreturnedonly: "Off — item hanya akan dicatat sebagai dikembalikan",
        Usedrestock: "Digunakan untuk menghitung penyesuaian laba saat restock",
        Willaddedbackconfirmation: "Akan ditambahkan kembali ke inventaris setelah konfirmasi",
        Returnreason: "Alasan pengembalian",
        Optional: "Opsional",
        SelectReason: "Pilih Alasan",
        Additionalnotes: "Catatan tambahan",
        Describeofcustomerexplanation: "Jelaskan kondisi barang yang dikembalikan, kerusakan yang terlihat, penjelasan pelanggan...",
        Requiredmustfilledcontinue: "Bidang yang wajib diisi harus dilengkapi untuk melanjutkan",
        Reviewdetailsbeforeconfirming: "Tinjau detail sebelum mengonfirmasi",
        Replacementproductwilldeductedinventoryconfirmation: "Produk pengganti akan dikurangi dari inventaris Anda setelah konfirmasi.",
        Choosereplacementproduct: "Pilih produk pengganti",
        Willdeductedfrominventoryconfirm: "Akan dikurangi dari inventaris setelah konfirmasi",
        Thesewillattachedothereturnrecord: "Gambar-gambar ini akan dilampirkan pada catatan pengembalian",
        Replacementitem: "Item pengganti",
        Addanotherproduct: "Tambah produk lain",
        Replacementproductwillbe: "Produk pengganti akan",
        deducted: "dikurangi",
        fromyourinventoryconfirmation: "dari inventaris Anda setelah konfirmasi.",
        productadjustedusingprice: "Produk yang dikembalikan akan di-restock dan laba disesuaikan menggunakan harga jual asli.",
        Willloggedreturnedonlynotrestocked: "Hanya akan dicatat sebagai dikembalikan — tidak di-restock",
        Returnonly: "Hanya pengembalian",
        Imagesofreturnedproduct: "Gambar produk yang dikembalikan",
        Returnedproductwill: "Produk yang dikembalikan",
        not: "tidak",
        berestockedloggedreturnedonly: "akan di-restock — hanya dicatat sebagai dikembalikan.",
        AddImage: "Tambah Gambar",
        STOCKIN: "STOK MASUK",
        LOGONLY: "HANYA CATAT",
        ContinuetoReview: "Lanjut ke Peninjauan →",
        Confirmreplacement: "Konfirmasi penggantian",
        Confirmreturn: "Konfirmasi pengembalian",
        Filldetailsbelowproceed: "Isi detail di bawah ini untuk melanjutkan",
        Review: "Tinjau",
        editdetails: "edit detail",
        Configurereturndetails: "Konfigurasi detail pengembalian",
        Configurereplacementdetails: "Konfigurasi detail penggantian",
        SelectSource: "Pilih Sumber",
        Returning: "Mengembalikan",
        Replacement: "Penggantian",
        WalkCustomer: "Pelanggan Umum",
        RETURNEDPRODUCT: "PRODUK DIKEMBALIKAN",
        REPLACEMENTPRODUCT: "PRODUK PENGGANTI",
        STOCKOUT: "STOK KELUAR",
        Netinventoryimpact: "Dampak inventaris bersih",
        Replacementitemcost: "Biaya item pengganti",
        Returneditemrestockvalue: "Nilai restock item yang dikembalikan",
        PROFITINVENTORYSUMMARY: "RINGKASAN LABA & INVENTARIS",
        Inventoryaction: "Tindakan inventaris",
        Valuededucted: "Nilai dikurangi",
        Profitadjustment: "Penyesuaian laba",
        stockedout: " stok keluar",
        restocked: " restock",
        Noaction: "Tidak ada tindakan",
        Valuebeingreturned: "Nilai yang dikembalikan",
        Willberestocked: "Akan di-restock",
        Willbe: "Akan",
        logged: "dicatat",
        ON: "AKTIF",
        OFF: "NONAKTIF",
        Linked: "Terhubung",
        Pleaseselectreturnedproduct: "Silakan pilih produk yang dikembalikan",
        Quantityrequired: "Kuantitas diperlukan",
        Buyingpricerequired: "Harga beli diperlukan",
        Pleaseaddleastreplacementproduct: "Silakan tambahkan setidaknya satu produk pengganti",
        Pleaseconfigurereturnedproductdetails: "Silakan konfigurasi detail produk yang dikembalikan",
        Pleaseselectcustomer: "Silakan pilih pelanggan",
        Returndateisrequired: "Tanggal pengembalian diperlukan",
        Pleasefillallrequiredfields: "Silakan isi semua field yang diperlukan",
        Wildeductedfrominventory: "Akan dikurangi dari inventaris",
        Currentprice: "Harga saat ini",
        Defectivedamaged: "Cacat / rusak",
        Wrongitemreceived: "Barang salah diterima",
        Customerchangedmind: "Pelanggan berubah pikiran",
        Sizefitissue: "Masalah ukuran / kecocokan",
        Notasdescribed: "Tidak sesuai deskripsi",
        Other: "Lainnya",
        Originalsaleprice: "Harga jual asli (penyesuaian laba)",
        Addedbackinventory: "Ditambahkan kembali ke inventori",
        Notaddedinventory: "Tidak ditambahkan ke inventori",
        replacedwith: "diganti dengan",
        deductedfrominventory: "dikurangi dari inventori",
        RETURNWITHSTOCKIN: "RETUR · DENGAN STOCK-IN",
        RETURNNOSTOCKIN: "RETUR · TANPA STOCK-IN",
        MULTIPLEREPLACEMENTS: "BANYAK PENGGANTIAN",
        SINGLEREPLACEMENT: "PENGGANTIAN TUNGGAL",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "DIKEMBALIKKAN · STOCK IN",
        REPLACEMENTSTOCKOUT: "PENGGANTIAN · STOCK OUT",
        Returnonlylogsthisentry: "Pengembalian hanya mencatat entri ini —",
        nostockwillbeaddedorremoved: "tidak ada stok yang akan ditambah atau dikurangi",
        frominventory: "dari inventaris.",
        Whentousethis: "Kapan menggunakan ini:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Gunakan Pengembalian di akhir hari untuk mencatat barang yang dikirim untuk penjualan yang kembali dalam keadaan rusak atau tidak dapat digunakan — barang yang ingin Anda lacak tetapi tidak dapat dimasukkan kembali ke inventaris.",
        Youcanviewallpastreturnentriesin: "Anda dapat melihat semua entri pengembalian sebelumnya di",
        ReturnHistory: "Riwayat Pengembalian",
        underthe: "di bawah tab",
        Others: "Lainnya",
        tab: ".",
        Negativestocktransactiondisabled: "Transaksi saham negatif dinonaktifkan."
    },
    NewRLocal: {
        Originalsaleprice: "Harga jual asli",
        Editinghistoryonlyinventorystaysunchanged: "Hanya mengedit riwayat — inventaris tetap tidak berubah.",
        Changeshereupdatethisdetailsquantitiesaffected: "Perubahan di sini hanya memperbarui detail catatan ini (alasan, tanggal, catatan). Jumlah stok aktual, lokasi bin, dan data produk Anda tidak terpengaruh.",
        Needtofixinventorylevelsinstead: "Perlu memperbaiki tingkat inventaris saja?",
        AdjustStock: "Sesuaikan Stok",
        Refund: "Pengembalian Dana",
        ImportantNote: "Catatan Penting",
        Pleasereviewbeforecontinuing: "Harap tinjau sebelum melanjutkan",
        Onceshippedreceivedanyupdatesmadeorder: "Setelah pesanan dikirim atau diterima, setiap pembaruan yang dilakukan pada pesanan tidak akan tercermin dalam riwayat transaksi.",
        Thisundone: "Ini akan menghapus pesanan secara permanen. Tindakan ini tidak dapat dibatalkan.",
        Inventorywilladjustedautomatically: "Inventaris tidak akan disesuaikan secara otomatis",
        Deletingthisreversevedshippedyouwillneed: "Menghapus ini tidak membatalkan perubahan stok apa pun. Jika item sudah diterima/dikirim, Anda perlu",
        reflectthecorrectstocklevels: "untuk mencerminkan tingkat stok yang benar.",
        manuallyadjustyourinventory: "sesuaikan inventaris Anda secara manual",
        Addremovestockforitemsthatwereshipped: "Tambah/hapus stok untuk item yang dikirim",
        Addremovestockforitemsthatwerereceived: "Tambah/hapus stok untuk item yang diterima",
        Updatecostrecordspaymentwaalreadymade: "Perbarui catatan biaya jika pembayaran sudah dilakukan",
        Reconcilerecordsandoutstandingpayments: "Rekonsiliasi catatan dan pembayaran yang belum lunas"
    },
    ReceivablesLocal: {
        Receivables: "Piutang",
        Manageandtrackcustomerduebalances: "Kelola dan pantau saldo jatuh tempo pelanggan",
        Viewcustomerduebalancereport: "Lihat laporan saldo jatuh tempo pelanggan",
        Viewsupplierduebalancereport: "Lihat laporan saldo jatuh tempo pemasok",
        DueBalance: "Saldo Jatuh Tempo",
        Unpaid: "Belum Dibayar",
        PartiallyPaid: "Dibayar Sebagian",
        Paid: "Sudah Dibayar",
        HighestBalance: "Saldo Tertinggi",
        LowestBalance: "Saldo Terendah",
        Filldetailsrecordpayment: "Isi detail untuk mencatat pembayaran",
        NewPaymentEntry: "Entri Pembayaran Baru",
        EditPaymentEntry: "Edit Entri Pembayaran",
        Nosuppliersfound: "Tidak ada pemasok ditemukan",
        Nocustomersfound: "Tidak ada pelanggan ditemukan",
        LowtoHigh: "Rendah ke Tinggi",
        HightoLow: "Tinggi ke Rendah",
        AttachmentUploadedSc: "Lampiran berhasil diunggah",
        AttachmentUploadedF: "Gagal mengunggah lampiran",
        Pay: "Bayar",
        NoBillsFound: "Tidak Ada Tagihan Ditemukan",
        Thiscustomerhasunpaidbills: "Pelanggan ini tidak memiliki tagihan yang belum dibayar.",
        TotalDue: "Total Terhutang",
        BillsFound: "Tagihan Ditemukan",
        DeselectAll: "Batalkan Pilihan Semua",
        SelectAll: "Pilih Semua",
        ShowDetails: "Tampilkan Detail"
    },
    AssetsNewLocal: {
        Assignedon: "Ditugaskan pada",
        Total: "Total",
        Assigned: "Ditugaskan",
        Remaining: "Tersisa",
        Available: "Tersedia",
        NoSerialNumbers: "Tidak ada nomor seri",
        UpdateExistingAssetDetails: "Perbarui detail aset yang ada",
        RegisterNewBusinessAsset: "Daftarkan aset bisnis baru",
        BasicInformation: "Informasi Dasar",
        AssetDetails: "Detail Aset",
        Quantity: "Jumlah",
        SerialNumbers: "Nomor Seri",
        SerialNumberPlaceholder: "Nomor seri",
        AddSerialNumber: "Tambah Nomor Seri",
        SerialNumbersOptional: "Nomor seri opsional. Anda dapat menambahkan hingga",
        AssetImages: "Gambar Aset",
        AdditionalNotes: "Catatan Tambahan",
        AdditionalNotesPlaceholder: "Detail tambahan atau riwayat pemeliharaan...",
        Updating: "Memperbarui...",
        Adding: "Menambahkan...",
        ITEquipmentPlaceholder: "misalnya Peralatan TI",
        LoadingMoreActivities: "Memuat lebih banyak aktivitas...",
        AssignedAssets: "Aset yang Ditugaskan",
        Noassetsassignedstaffmember: "Tidak ada aset yang ditugaskan ke staf ini.",
        Assignassetstaff: "Tetapkan aset ke staf",
        Returnassetfromstaff: "Kembalikan aset ini dari staf",
        AssignmentDetails: "Detail Penugasan",
        Serial: "Serial",
        ViewAssets: "Lihat Semua Aset",
        ViewByStaff: "Lihat Berdasarkan Staf",
        AssignedHistory: "Riwayat Penugasan",
        Returned: "Dikembalikan",
        Returnedon: "Dikembalikan pada",
        ReturnedBy: "Dikembalikan oleh",
        AssignedTo: "Ditugaskan ke",
        NoHistoryRecords: "Tidak ada riwayat",
        Selectstaffmemberviewtheirassets: "Pilih anggota staf untuk melihat aset mereka.",
        Deleted: "DIHAPUS",
        searchPlaceholder: "Cari aset berdasarkan nama atau nomor seri..."
    },
    InventoryCountLocale: {
        InventoryCount: "Penghitungan Inventori",
        Viewinventorycountreport: "Lihat laporan penghitungan inventori",
        ItemsCount: "Jumlah Item",
        All: "Semua",
        InProgress: "Dalam Proses",
        Submitted: "Dikirim",
        awaitingreview: "Menunggu Review",
        EditInventoryCount: "Edit Penghitungan Inventori",
        NewInventoryCount: "Penghitungan Inventori Baru",
        Modifyinventorycountsheetdetails: "Ubah detail lembar penghitungan",
        Startanewinventorycountsheet: "Mulai lembar penghitungan baru",
        GeneralInformation: "Informasi Umum",
        Title: "Judul",
        SaveChanges: "Simpan Perubahan",
        Selectproductsforthisinventorycountsheet: "Pilih produk untuk lembar ini",
        InventoryCountDetails: "Detail Penghitungan Inventori",
        Inventorycountsheetdetails: "Detail lembar penghitungan inventori",
        Viewingdetailsforcountsheet: "Melihat detail lembar penghitungan",
        Started: "Dimulai",
        TaskSheets: "Lembar Tugas",
        Allitems: "Semua item",
        NotStarted: "Belum Dimulai",
        Completed: "Selesai",
        Results: "Hasil",
        ViewResults: "Lihat Hasil",
        DeleteInventoryCount: "Hapus Penghitungan Inventori",
        Viewingtransactionandadjustments: "Melihat log transaksi dan penyesuaian stok",
        Productsadjusted: "Produk yang disesuaikan",
        Assignee: "Ditugaskan kepada",
        Tasksheetdetails: "Detail lembar tugas",
        Draft: "Draf",
        VariantQuantities: "Jumlah Varian",
        AssignedProducts: "Produk yang Ditugaskan",
        ReturnAsset: "Kembalikan Aset",
        EditTasksheet: "Edit Lembar Tugas",
        NewTasksheet: "Lembar Tugas Baru",
        Updatetasksheetdetails: "Perbarui detail lembar tugas",
        Starttasksheetforthisinventorycount: "Mulai lembar tugas baru untuk penghitungan ini",
        TaskSheetInformation: "Informasi Lembar Tugas",
        SheetTitle: "Judul Lembar",
        Entersheettitle: "Masukkan judul lembar",
        SubmissionResult: "Hasil Pengiriman",
        ReviewChanges: "Tinjau Perubahan",
        Viewingsubmissionresultsforthisinventorycount: "Melihat hasil pengiriman untuk penghitungan ini",
        Reviewyourinventorycountbeforesubmitting: "Tinjau penghitungan inventori Anda sebelum mengirim"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Gagal memuat hitungan",
        NoInventoryCounts: "Tidak Ada Penghitungan Inventori",
        NoMatches: "Tidak Ada yang Cocok",
        Therearenoinventorycountswiththestatus: "Tidak ada penghitungan inventori dengan status",
        Noinventorycountsfoundyoursearchterm: "Tidak ditemukan penghitungan inventori yang sesuai dengan kata pencarian Anda.",
        Thereareinventorycountsrecordedyetforthisbusiness: "Belum ada penghitungan inventori yang tercatat untuk bisnis ini."
    },
    StockinModalP: {
        StockInNow: "Masukkan Stok Sekarang",
        Settheopeningquantityforthisproductrightnow: "Tetapkan jumlah awal untuk produk ini sekarang.",
        Addinitialstock: "Tambah stok awal?",
        dothislater: "Saya akan melakukannya nanti",
        Productadded: "Produk berhasil ditambahkan!",
        isready: "sudah siap.",
        SeeHowItWorks: "Lihat Cara Kerjanya",
        NoSalesOrdersFound: "Tidak Ada Pesanan Penjualan Ditemukan",
        NoPurchaseOrdersFound: "Tidak Ada Pesanan Pembelian Ditemukan",
        Startcreatingoutgoinginventoryrevenue: "Mulai buat pesanan penjualan untuk melacak inventori keluar dan pendapatan.",
        Trackrestockssupplierplace: "Lacak restock inventori dan pesanan supplier di satu tempat.",
        CreateSalesOrder: "Buat Pesanan Penjualan",
        CreatePurchaseOrder: "Buat Pesanan Pembelian",
    },
    dialy_report: "Laporan Pergerakan Harian",
    Quotation: "Penawaran",
    Quote: "Penawaran",
    Assignee: "Ditugaskan kepada",
    dayStart: "Awal hari",

    ShowTotalAmount: "Total Jumlah",

    tutorial: {
        watchTitle: 'Tonton tutorial langkah demi langkah',
        watchDesc: 'Pelajari SimplyStock di saluran YouTube kami',
        modalTitle: 'Tetap di depan dengan SimplyStock',
        modalDesc: 'Berlangganan untuk mendapatkan tutorial baru saat mereka berhenti berlangganan',
        feature1Title: 'Panduan fitur baru',
        feature1Sub: 'Setiap pembaruan baru dijelaskan dengan video singkat — jadi Anda tidak pernah melewatkan apa yang baru',
        feature2Title: 'Video petunjuk cepat',
        feature2Sub: 'Siapkan stok, faktur, akses staf, dan lainnya dalam waktu kurang dari 5 menit',
        feature3Title: 'Notifikasi Instan',
        feature3Sub: 'Dapatkan pemberitahuan saat tutorial baru ditayangkan — pelajari sesuai keinginan Anda',
        feature4Title: '100% gratis, selalu',
        feature4Sub: 'Semua tutorial gratis selamanya — tidak perlu login atau berlangganan',
        subscribeBtn: 'Berlangganan SimplyStock',
        maybeLater: 'Mungkin Nanti'
    }
    ,
    dailyCashReport: {
        "title": "Laporan Kas Harian",
        "subtitle": "Siapa membayar apa, tanggal berapa, dan apa yang masih terutang — dikelompokkan dari Detail Penjualan.",
        "totalSales": "Total penjualan",
        "cashReceived": "Total Diterima",
        "outstanding": "Belum lunas",
        "collectionRate": "Tingkat penagihan",
        "grandTotalAllDates": "TOTAL KESELURUHAN (semua tanggal)",
        "totalLabel": "Total",
        "loading": "Memuat...",
        "noData": "Tidak ada data ditemukan untuk rentang tanggal tersebut.",
        "loadingMore": "Memuat lebih banyak..."
    },
    dailyCashReportColumns: {
        "date": "Tanggal",
        "customer": "Pelanggan",
        "productsSold": "Produk Terjual",
        "products": "Produk",
        "salesAmount": "Jumlah Penjualan",
        "sales": "Penjualan",
        "received": "Total Diterima",
        "receivedShort": "Diterima",
        "debited": "Didebit ke Buku Besar",
        "due": "Jatuh Tempo",
        "paymentModes": "Mode Pembayaran",
        "mode": "Mode"
    },
}

export default id
